import { CommandBar, Panel, PanelType, Stack } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import { DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import PerimetreContext from '../../contexts/PerimetreContext.js';
import { Data } from '../../data/Data.jsx';
import { DataCommercialisation } from '../../data/DataCommercialisation';
import { DataCompte } from '../../data/DataCompte.jsx';
import { DataContact } from '../../data/DataContact.jsx';
import { DataFinancement } from '../../data/DataFinancement';
import { DataLotCommercial } from '../../data/DataLotCommercial.jsx';
import { DataMandat } from '../../data/DataMandat';
import { DataOption } from '../../data/DataOption';
import { DataReservation } from '../../data/DataReservation';
import { Immocom } from '../../specifique/immocom';
import { BlocReservation } from '../Bloc/BlocReservation';
import { ComboBoxEcheancier } from '../ComboBox/ComboBoxEcheancier.jsx';
import { ComboBoxReservation } from '../ComboBox/ComboBoxReservation.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUIDialog } from '../EUI/EUIDialog.jsx';
import { EUIPanel } from '../EUI/EUIPanel.jsx';
import { DetailsListDemande } from '../List/DetailsListDemande';
import { DetailsListOperation_Echeancier_Stade } from '../List/DetailsListOperation_Echeancier_Stade.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { SpinnerChargement } from '../Loader/SpinnerChargement';
import { MessageBars } from '../Outils/MessageBars';
import { Timeline } from '../Timeline/Timeline';
import { FicheCalendrierReservation } from './FicheCalendrierReservation';
import { FicheChecklistItems_Reservation } from './FicheChecklistItems_Reservation';
import { FicheCommentaire } from './FicheCommentaire';
import { FicheCommercialisation } from './FicheCommercialisation';
import { FicheContact } from './FicheContact/FicheContact';
import { FicheDepotGarantie } from './FicheDepotGarantie';
import { FicheDossierClient } from './FicheDossierClient';
import { FicheFinancement } from './FicheFinancement';
import { FicheFraisNotaire } from './FicheFraisNotaire';
import { FicheNotaire } from './FicheNotaire';
import './FicheReservation.css';
import { FicheReservationCycle } from './FicheReservationCycle';
import { FicheReservation_Echeancier } from './FicheReservation_Echeancier';
import { FicheSuiviCompteClient } from './FicheSuiviCompteClient';
import { FicheSuiviNotaire } from './FicheSuiviNotaire';
import { FicheTarifReservation } from './FicheTarifReservation';
import { FicheTMA } from './FicheTMA';

/*
***************************************************************
 PROPS:
    idReservation
    idOperation
    idLotCommercial

    onAffichePanelReservation

    onFermeFicheReservation : méthode
    onEnregistrementFiche : méthode
    onRechargeFiche : méthode

    provientDeADVv2 : booléen

    classnameinner : classe CSS (string)
    classname : classe CSS (string)
***************************************************************
*/

const listeEtapes = [
    { numEtape: 1, icone: "Contact", nomEtape: "Contacts et souhaits", onClick: null },
    { numEtape: 2, icone: "AccountManagement", nomEtape: "Commercialisateurs", onClick: null },
    { numEtape: 3, icone: "Money", nomEtape: "Tarifs", onClick: null },
    { numEtape: 4, icone: "Calendar", nomEtape: "Dates", onClick: null },
    { numEtape: 5, icone: "TimelineProgress", nomEtape: "Echéancier", onClick: null },
    { numEtape: 6, icone: "Chat", nomEtape: "Commentaires", onClick: null }
];

var objetState = {
    idOperation: 0,
    idLotCommercial: 0,
    idReservation: 0,
    idSouhait: 0,

    monCompte: {},
    reservation: {},
    contact: {},
    commercialisateur: {},

    selectionContacts: [],
    listContacts: [],
    listSouhaitsDuContact: [],
    listCommercialisateurs: [],
    listFinancements: [],
    desistement: {},
    listEtatsReservation: [],
    listeDesTVAs: [],
    //listeDesReservations: [],

    titreReservation: null,

    onActiveBoutonEnregistrer: false,
    onActiveBoutonEnregistrerDesistement: false,


    affichageSectionContacts_ModeCreation: false,//new
    affichageSectionReservationTarifs_ModeCreation: false,
    affichageSectionReservationDates_ModeCreation: false,
    affichageSectionReservationEcheancier_ModeCreation: false,
    affichageSectionReservationCommentaire_ModeCreation: false,

    affichageFicheContact: false,
    affichageCommercialisateurs: false,
    affichageOngletDesSouhaits: false,
    affichageFicheReservation: false,
    affichageAcquereur: false,
    affichageCommercialisateur: false,
    affichageConditionsParticulieres: false,
    affichageDateAutre: false,
    affichageDateReservation: false,
    affichageDepotGarantie: false,
    affichageDossierClient: false,
    affichageEcheancier: false,
    affichageEtat: false,
    affichageLot: false,
    affichageNotaireClient: false,
    affichagePrix: false,
    affichageSuiviCompteClient: false,
    affichageTMA: false,
    affichageDemandes: false,
    affichageChecklist: false,

    affichagePanelAcquereurs: false,
    affichagePanelCommercialisateur: false,
    affichagePanelNotaire: false,
    affichagePanelFraisNotaire: false,
    affichagePanelDepotGarantie: false,
    affichagePanelCommentaire: false,
    affichagePanelTarif: false,
    affichagePanelDates: false,
    affichagePanelFinancement: false,
    affichagePanelCycle: false,
    affichagePanelSuiviNotaire: false,

    affichageSignatureClient: false,
    affichageValidationEiffage: false,
    affichageSignatureEiffage: false,
    affichageSignatureActe: false,

    affichageDialogDesistement: false,
    afficheDialogSuppressionContact: false,
    afficheDialogSuppressionReservation: false,
    affichageDialogVeuillezEditerLeContact: false,
    afficheDialogConfirmationVerrouillageReservation: false,
    afficheDialogConfirmationValidationDonnees: false,
    afficheDialogSuppressionCommercialisateur: false,
    afficheDialogVerrouillageReservation: false,
    afficheDialogValidationReservation: false,
    messageDialogValidationReservation: '',

    //******************************
    //#region mode modification
    ficheReservation: {
        estChargee: false,
        reservation: {},
        listSouhaits: [],
        tva: [],
        listLots: [],
        prixMaitrise: {},
        listTVA: [],
        listCommercialisateurs: [],
        listContacts: [],
        nbADF: 0,
        lotCommercial: {},
        echeancier: {},
        existeDocumentsSigneEiffage: false,
        existeDocumentsASignerParEiffage: false
    },
    idContactSelectionne: 0,
    commercialisateurSelectionne: {},

    onActiveVerrouillageReservation: false,
    //#endregion

    //#region DROITS
    peutAccederBlocAcquereur: false,
    peutAjouterBlocAcquereur: false,
    peutModifierBlocAcquereur: false,
    peutSupprimerBlocAcquereur: false,

    peutAccederBlocCommercialisateur: false,
    peutAjouterBlocCommercialisateur: false,
    peutModifierBlocCommercialisateur: false,
    peutSupprimerBlocCommercialisateur: false,

    peutAccederBlocSuiviCompteClient: false,
    peutAjouterBlocSuiviCompteClient: false,
    peutModifierBlocSuiviCompteClient: false,
    peutSupprimerBlocSuiviCompteClient: false,

    peutAccederBlocConditionsParticulieres: false,
    peutModifierBlocConditionsParticulieres: false,

    peutAccederBlocDateReservation: false,
    peutModifierBlocDateReservation: false,

    peutAccederBlocDepotGarantie: false,
    peutModifierBlocDepotGarantie: false,

    peutAccederBlocDossierClient: false,
    peutAjouterBlocDossierClient: false,
    peutModifierBlocDossierClient: false,

    peutAccederBlocEcheancier: false,
    peutModifierBlocEcheancier: false,//YD : 06/02/2020
    peutSupprimerBlocEcheancier: false,//YD : 06/02/2020
    peutVerrouillerEcheancier: false,

    peutAccederBlocEtat: false,
    peutModifierBlocEtat: false,//YD : 06/02/2020

    peutAccederBlocFinancement: false,
    peutAjouterBlocFinancement: false,
    peutModifierBlocFinancement: false,
    peutSupprimerBlocFinancement: false,

    peutAccederBlocNotaire: false,
    peutModifierBlocNotaire: false,

    peutAccederBlocFraisNotaire: false,
    peutModifierBlocFraisNotaire: false,

    peutAccederBlocPrix: false,
    peutModifierBlocPrix: false,
    peutAjouterBlocPrix: false,
    peutSupprimerBlocPrix: false,

    peutAccederBlocTMA: false,
    peutAjouterBlocTMA: false,
    peutModifierBlocTMA: false,
    peutSupprimerBlocTMA: false,

    peutAccederBlocDemandes: false,
    peutAccederBlocChecklist: false,

    peutAccederBlocSuiviNotaire: false,
    peutModifierBlocSuiviNotaire: false,

    peutSupprimer: false,
    peutDesister: false,

    peutModifierChoixEcheancier: false,
    //#endregion

    activationValidation: false,
    activationValidationCG: false,
    dernierCycleReservation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheReservation extends Component {

    static defaultProps = {
        inclureVentesEnBloc: false
    };

    static contextType = PerimetreContext;

    _creationContent = () => {

        const { idOperation } = this.props;

        if (this.props.idReservation === 0 || this.props.idReservation == null) {
            let renderFooterContent = null;
            let numEtape = 0;
            let disabledButtonRetirerContact = true;

            if (this.state.selectionContacts !== null && this.state.selectionContacts != undefined) {
                disabledButtonRetirerContact = this.state.selectionContacts.length === 0;
            }

            if (this.state.affichageSectionContacts_ModeCreation) {
                renderFooterContent = this._onRenderFooterContentContact;
                numEtape = 1;
            }
            else if (this.state.affichageFicheContact) {
                numEtape = 1;
            }
            else if (this.state.affichageCommercialisateurs) {
                renderFooterContent = this._onRenderFooterContentCommercialisateur;
                numEtape = 2;
            }
            else if (this.state.affichagePanelCommercialisateur) {
                numEtape = 2;
            }
            else if (this.state.affichageSectionReservationTarifs_ModeCreation) {
                renderFooterContent = this._onRenderFooterContentTarifs;
                numEtape = 3;
            }
            else if (this.state.affichageSectionReservationDates_ModeCreation) {
                renderFooterContent = this._onRenderFooterContentDates;
                numEtape = 4;
            }
            else if (this.state.affichageSectionReservationEcheancier_ModeCreation) {
                renderFooterContent = this._onRenderFooterContentEcheancier;
                numEtape = 5;
            }
            else if (this.state.affichageSectionReservationCommentaire_ModeCreation) {
                renderFooterContent = this._onRenderFooterContentCommentaire;
                numEtape = 6;
            }

            return <Panel
                isLightDismiss
                isOpen={this.props.onAffichePanelReservation}
                type={PanelType.extraLarge}
                onDismiss={this._onAnnulation}
                headerText={this.state.titreReservation}
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={renderFooterContent}
                onOpen={this._onOpen}
                styles={{ content: { height: "100%" } }}
            >
                <Timeline listeEtapes={listeEtapes} etapeActive={numEtape} />

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                {(this.state.affichageSectionContacts_ModeCreation ?
                    <div>
                        <div className="ms-Grid-col ms-sm12">
                            <PrimaryButton text="Ajouter un contact" name="noveauContact" className="boutonReservation" onClick={() => this._onAffichagePanelContact(null)} />
                            <DefaultButton text="Retirer un contact" disabled={disabledButtonRetirerContact} onClick={() => this._onCacheDialogSuppressionContact()} />
                        </div>
                        <div className="ms-Grid-col ms-sm12">

                            <DetailsList
                                className="containerReservation"
                                items={this.state.listContacts}
                                selectionMode={SelectionMode.multiple}
                                columns={this.columnsContacts}
                                selection={this._selectionContactARetirer}
                            />

                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <div className="zoneAide">Cet écran vous permet d'ajouter des contacts si aucun contact n'est sélectionné ou de modifier la fiche contact. Lors d'une réservation, en cliquant sur l'icône d'édition (crayon), vous pourrez décrire le bien recherché par le contact (SOUHAIT) soit en sélectionnant un souhait existant soit en complétant le souhait pré-rempli correspondant au lot réservé.</div>
                        </div>

                        <Dialog
                            hidden={!this.state.affichageDialogVeuillezEditerLeContact}
                            onDismiss={this._onCacheDialogVeuillezEditerLeContact}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: 'Finalisation du contact et du souhait associé',
                                subText: 'Merci de compléter vos informations sur le contact et de sélectionner un souhait en utilisant le bouton d\'édition du contact.'
                            }}
                            modalProps={{
                                isBlocking: true,
                                styles: { main: { maxWidth: 450 } }
                            }}
                        >
                            <DialogFooter>
                                <PrimaryButton onClick={this._onCacheDialogVeuillezEditerLeContact} text="OK" />
                            </DialogFooter>
                        </Dialog>

                        <Dialog
                            hidden={!this.state.afficheDialogSuppressionContact}
                            onDismiss={this._onCacheDialogSuppressionContact}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: `Retrait ${this.state.selectionContacts.length > 1 ? 'des' : 'du'} contact`,
                                subText: `Etes-vous certain de vouloir retirer ${this.state.selectionContacts.length > 1 ? 'ces contacts' : 'ce contact'} de la réservation ?`
                            }}
                            modalProps={{
                                isBlocking: true,
                                styles: { main: { maxWidth: 450 } }
                            }}
                        >
                            <DialogFooter>
                                <PrimaryButton onClick={this._onSuppressionContactDeLaSelection} text="Retirer" />
                                <DefaultButton onClick={this._onCacheDialogSuppressionContact} text="Annuler" />
                            </DialogFooter>
                        </Dialog>
                    </div>
                    :
                    null)}

                <FicheContact
                    isOpen={this.state.affichageFicheContact}
                    appelFicheContactEnModeCreation
                    idContact={this.state.contact.idContact}

                    onAnnuleFiche={() => this._onCachePanelContact()}
                    onEnregistrementFiche={(contact) => alert("L'enregistrement a bien été effectué. Veuillez maintenant sélectionner un souhait.")}
                    //onRechargeFiche={(idContactSelectionne) => this._onRechargeFicheContact(idContactSelectionne)}
                    onAfficheOngletsSouhaitEtSouhaitMaisonIdividuelle={() => this.setState({ affichageOngletDesSouhaits: true })}

                    pasDAccesAuxSouhaits={!this.state.affichageOngletDesSouhaits}
                    pasDAccesAuxSouhaitsMaisonIndividuelle={!this.state.affichageOngletDesSouhaits}
                    pasDAccesAuxDenonciations
                    pasDAccesAHistorique

                    modeSelectionDeSouhait={SelectionMode.single}
                    onSelectionSouhait={(e) => this._onSelectionSouhait(e)}
                    idLotCommercial={this.state.idLotCommercial}
                    idOperation={this.state.idOperation}

                    titre={`${this.state.titreReservation} / ${(this.state.contact.idContact == null ? "Ajouter un contact" : "Edition de contact")}`}
                    listeEtapesTimeline={listeEtapes}
                    numEtape={1}

                    appelDepuisReservation

                //onPeutChargerLeComposant={this.state.affichageFicheContact}
                />

                {(this.state.affichageCommercialisateurs && !this.state.peutModifierBlocCommercialisateur ?
                    <div className="ms-Grid-col ms-sm12">
                        <DetailsList
                            className="containerReservation"
                            items={this.state.listCommercialisateurs}
                            selectionMode={SelectionMode.none}
                            columns={this.columnsCommercialisateurs}
                        />
                    </div>
                    :
                    null)}

                {(this.state.affichageCommercialisateurs && this.state.peutModifierBlocCommercialisateur ?
                    <div>
                        <div className="ms-Grid-col ms-sm12">
                            <PrimaryButton name="ajouterCommercialisateur" text="Ajouter un commercialisateur" onClick={() => this._onAffichagePanelCommercialisateur()} />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <DetailsList
                                className="containerReservation"
                                items={this.state.listCommercialisateurs}
                                selectionMode={SelectionMode.none}
                                columns={this.columnsCommercialisateurs}
                            />
                        </div>
                        <div className="ms-Grid-col ms-sm12">
                            <div className="zoneAide">Au moins un commercialisateur doit être enregistré pour poursuivre votre processus de réservation.</div>
                        </div>

                        <Dialog
                            hidden={!this.state.afficheDialogSuppressionCommercialisateur}
                            onDismiss={this._onCacheDialogSuppressionCommercialisateur}
                            dialogContentProps={{
                                type: DialogType.normal,
                                title: 'Retrait du commercialisateur',
                                subText: `Etes-vous certain de vouloir retirer ce commercialisateur (${this.state.commercialisateurSelectionne.nomComplet} - ${this.state.commercialisateurSelectionne.nomSociete}) ?`
                            }}
                            modalProps={{
                                isBlocking: true,
                                styles: { main: { maxWidth: 450 } }
                            }}
                        >
                            <DialogFooter>
                                <PrimaryButton onClick={() => this._onSuppressionCommercialisateur(this.state.commercialisateurSelectionne)} text="Valider" />
                                <DefaultButton onClick={this._onCacheDialogSuppressionCommercialisateur} text="Annuler" />
                            </DialogFooter>
                        </Dialog>
                    </div>
                    :
                    null)}

                <FicheCommercialisation
                    commercialisateur={this.state.commercialisateur}
                    idOperation={this.state.idOperation}
                    idLotCommercial={this.state.idLotCommercial}
                    loginCompte={(this.state.commercialisateur !== undefined ? (this.state.commercialisateur.loginCompte !== undefined ? this.state.commercialisateur.loginCompte : null) : null)}
                    onAffichePanelCommercialisateur={this.state.affichagePanelCommercialisateur}
                    onAnnuleFiche={() => this._onCachePanelCommercialisateur()}
                    onEnregistrementFiche={(listCommercialisateur) => this._onCachePanelCommercialisateurEtAjoutDuCommercialisateurEnModeCreationDeReservation(listCommercialisateur)}
                />

                {(this.state.affichageSectionReservationTarifs_ModeCreation ?
                    <div>
                        <div className="sousTitreReservation">Renseignement des tarifs</div>
                        <FicheTarifReservation
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            reservation={this.state.reservation}
                            listeDesTVAs={this.state.listeDesTVAs}
                            peutModifierBlocPrix={this.state.peutModifierBlocPrix}
                            onAffichageSansPanel
                            onChange={(nomPropriete, valeur) => Scriba.state().setObjetPropriete(this, "reservation", nomPropriete, valeur, this._onVerificationFormulaireTarifReservation)}
                        />
                    </div>
                    :
                    null)}

                {(this.state.affichageSectionReservationDates_ModeCreation ?
                    <div>
                        <div className="sousTitreReservation">Renseignement des dates</div>
                        <FicheCalendrierReservation
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            idLotCommercial={this.state.idLotCommercial}
                            onAffichageSansPanel
                            onChange={(nomPropriete, valeur) => Scriba.state().setObjetPropriete(this, "reservation", nomPropriete, valeur, this._onVerificationFormulaireCalendrierReservation)}
                            peutModifierBlocDateReservation={this.state.peutModifierBlocDateReservation}
                        />
                    </div>
                    :
                    null)}

                {this.state.affichageSectionReservationEcheancier_ModeCreation &&
                    <div>
                        <div className="sousTitreReservation">Renseignement de l'échéancier</div>
                        <div className="zoneAide" style={{ marginBottom: "10px" }}>Sélectionner un échéancier type. Si des adaptations sont nécessaires elles seront réalisées par vos correspondants chez Eiffage Immobilier.</div>
                        <ComboBoxEcheancier
                            idOperation={idOperation}
                            onChange={(event, option, index, value, item) => this.setState(prevState => {
                                let reservation = { ...prevState.reservation };
                                reservation.idEcheancier = item.idEcheancier;
                                return { reservation };
                            })}
                            onLoad={(selectedEcheancier, echeanciers) => !this.state.reservation.idEcheancier && !!echeanciers && Array.isArray(echeanciers) && echeanciers.length > 0 && this.setState(prevState => {
                                let reservation = { ...prevState.reservation };
                                reservation.idEcheancier = echeanciers[0].idEcheancier;
                                return { reservation };
                            })}
                            placeholder="Sélectionnez"
                            required
                            selectedKey={this.state.reservation.idEcheancier}
                        />
                        <DetailsListOperation_Echeancier_Stade
                            idEcheancier={this.state.reservation.idEcheancier}
                            idOperation={idOperation}
                        />
                    </div>
                }

                {
                    (this.state.affichageSectionReservationCommentaire_ModeCreation ?
                        <div>
                            <div className="sousTitreReservation">Renseignement des commentaires</div>
                            <FicheCommentaire
                                idOperation={this.state.idOperation}
                                idReservation={this.state.idReservation}
                                onAffichageSansPanel
                                onChangeValeurMultiple={(tablValeurModifiee) => this._onChangeCommentaire(tablValeurModifiee)}
                            />
                        </div>
                        :
                        null)
                }
            </Panel >;
        }
        else {

            const { ficheReservation } = this.state;
            const { reservation } = ficheReservation;

            var objTravailAffichage = {
                fichesKYCEnabled: false,
                ficheInfoPrecontractuelleEnabled: false,
                estValidationEiffageEnabled: false,

                ficheKYCVisible: false,
                ficheInfoPrecontractuelleVisible: false
            };
            var aucunAppelsDeFondsEffectues = (ficheReservation.nbADF == 0);

            FicheReservationCycle._onChargement_KYC_PreContractuelle_ValidationEiffage(reservation, this.state.peutModifierBlocEtat, this.state.activationValidation, objTravailAffichage, aucunAppelsDeFondsEffectues);


            /*            const estValidationEiffageDisabled =
                                ((!this.state.peutModifierBlocEtat || !this.state.activationValidation) &&
                            (new Date(reservation.dateReservation) >= new Date(2021, 3, 1) && !(reservation.fichesKyc && reservation.ficheInfoPrecontractuelle)); // A compter de mars 2021 : fiches KYC + info précontractuelle obligatoires
            */

            this._validationFormulaireDesistement(this.state.desistement);
            let boutonActif = this.state.onActiveBoutonEnregistrerDesistement;
            let prixTTC = null;

            if (ficheReservation.estChargee && reservation.prixHT !== null) {
                if (ficheReservation.tva.length > 0) {
                    prixTTC = (reservation.prixHT * (parseFloat(ficheReservation.tva[0].taux) + 1)).toFixed(2);
                }
                else {
                    if (this.state.hideMessageBarWarning) {
                        this.setState({
                            hideMessageBarWarning: false,
                            warningMessage: 'Problème lié à la TVA'
                        });
                    }
                }
            }

            let commercialisateurs = [];
            let contacts = [];

            // Section
            if (this.state.affichageFicheReservation) {
                ficheReservation.listCommercialisateurs.forEach(function (commercialisateur) {
                    //commercialisateurs.push(<div key={commercialisateur.loginCompte}>{commercialisateur.nomSociete + ' (' + commercialisateur.nomComplet + ')'}</div>);
                    commercialisateurs.push(<div key={commercialisateur.loginCompte}>{commercialisateur.societeNomAffichage}</div>);
                });

                ficheReservation.listContacts.forEach(function (contact) {
                    contacts.push(<div key={contact.idContact} className="ms-Grid-col ms-sm12 blocContactReservation">
                        <div className="ms-Grid-col ms-sm12 nomContact">{contact.civilite} {contact.nom.toUpperCase()} {contact.prenom}</div>
                        <div className="ms-Grid-col ms-sm12">{contact.adresse} {contact.cp} {contact.ville}</div>
                        <div className="ms-Grid-col ms-sm12">Port. : {contact.tel1}</div>
                        <div className="ms-Grid-col ms-sm12">Fixe : {contact.tel2}</div>
                        <div className="ms-Grid-col ms-sm12">Email : {contact.email}</div>
                        <div className="ms-Grid-col ms-sm12">Motif : {contact.rechercheMotifAcquisition}</div>
                        <div className="ms-Grid-col ms-sm12">Origine : {contact.rechercheOrigineCommerciale}</div>
                    </div>);
                });
            }

            const onRenderHeader = (props, defaultRender) => {
                return !!props.headerText &&
                    <Stack horizontal>
                        <Stack.Item grow>{defaultRender(props)}</Stack.Item>
                        {!this.props.provientDeADVv2 &&
                            <Stack horizontal verticalAlign="center" styles={{ root: { marginTop: "auto", marginBottom: "14px", paddingRight: "32px" } }}>
                                {/*
                                <div className="titreChoixReservation ms-hiddenMdDown">Réservation&nbsp;:</div>
                                <ComboBox
                                    selectedKey={this.props.idReservation}
                                    autoComplete="on"
                                    options={this.state.listeDesReservations}
                                    onChanged={(e) => this.props.onChangeDeReservation(e.key)}
                                />
                                */}
                                <ComboBoxReservation
                                    idOperation={this.props.idOperation}
                                    inclureVentesEnBloc={this.props.inclureVentesEnBloc}
                                    label=""
                                    onChange={(event, option) => this.props.onChangeDeReservation(option.key)}
                                    selectedKey={this.props.idReservation}
                                />
                            </Stack>
                        }
                    </Stack>
            };

            return <Panel
                closeButtonAriaLabel="Fermer"
                headerText={this.state.titreReservation}
                isLightDismiss
                isOpen={this.props.onAffichePanelReservation}
                onDismiss={this._onAnnulation}
                onRenderFooterContent={this._onRenderFooterContentReservation}
                onRenderHeader={onRenderHeader}
                styles={{ content: { height: "100%" } }}
                type={this.props.provientDeADVv2 ? PanelType.smallFluid : PanelType.extraLarge}
            >

                {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                <Stack verticalFill verticalAlign="stretch">

                    <MessageBars
                        errorMessage={this.state.errorMessage}
                        warningMessage={this.state.warningMessage}
                        onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                        onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                    />

                    {/*<Timeline listeEtapes={this.state.listEtatsReservation} etapeActive={(this.state.operationCycle !== null ? this.state.operationCycle.idCycleOperation / 10 : 0)} />*/}
                    <Timeline listeEtapes={this.state.listEtatsReservation} etapeActive={this.state.etapeActive || 0} />

                    <nav className="navbar navbar-expand-lg navbar-light border-bottom">
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavFicheReservation" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarNavFicheReservation">
                            <ul className="navbar-nav">
                                {this.state.peutAccederBlocEtat ? <li className={`nav-item itemNavigationReservation ${(this.state.affichageFicheReservation ? 'active' : '')}`} onClick={this._onSelectionOnglet("FicheReservation")}>Réservation</li> : null}
                                {this.state.peutAccederBlocEcheancier ? <li className={`nav-item itemNavigationReservation ${(this.state.affichageEcheancier ? 'active' : '')}`} onClick={this._onSelectionOnglet("Echeancier")}>échéancier</li> : null}
                                {this.state.peutAccederBlocDossierClient ? <li className={`nav-item itemNavigationReservation ${(this.state.affichageDossierClient ? 'active' : '')}`} onClick={this._onSelectionOnglet("DossierClient")}>Dossier client</li> : null}
                                {this.state.peutAccederBlocSuiviCompteClient ? <li className={`nav-item itemNavigationReservation ${(this.state.affichageSuiviCompteClient ? 'active' : '')}`} onClick={this._onSelectionOnglet("SuiviCompteClient")}>Suivi compte client</li> : null}
                                {this.state.peutAccederBlocTMA ? <li className={`nav-item itemNavigationReservation ${(this.state.affichageTMA ? 'active' : '')}`} onClick={this._onSelectionOnglet("TMA")}>TMA</li> : null}
                                {this.state.peutAccederBlocDemandes ? <li className={`nav-item itemNavigationReservation ${(this.state.affichageDemandes ? 'active' : '')}`} onClick={this._onSelectionOnglet("Demandes")}>Demandes</li> : null}
                                {this.state.peutAccederBlocChecklist ? <li className={`nav-item itemNavigationReservation`} onClick={() => this.setState({ affichageChecklist: true })}>Checklist</li> : null}
                            </ul>
                        </div>
                    </nav>

                    {/*{sectionAfficher}*/}
                    {/*YD : 01/07/2020 supp : (reservation.estValideeCG ? null :*/}

                    {(this.state.affichageFicheReservation && ficheReservation.estChargee ?//this.state.affichageFicheReservation && 
                        <div className="ms-Grid" dir="ltr">
                            {ficheReservation.nbADF > 0 ? null :
                                <div className="ms-Grid-row" style={{ marginTop: '15px' }} name="divSuppressionDesistement">
                                    {this.state.peutDesister
                                        ?
                                        <PrimaryButton onClick={() => this._onAffichageDialogDesistement()} className="boutonReservation">Désister</PrimaryButton>
                                        :
                                        null
                                    }

                                    {this.state.peutSupprimer
                                        //&& this.state.dernierCycleReservation.idCycleReservation == 10
                                        //&& !reservation.estValideeCG
                                        ? <PrimaryButton name="buttonSuppression" onClick={() => this._onAffichageDialogSuppressionReservation()}>Supprimer</PrimaryButton>
                                        :
                                        null
                                    }

                                    {/*YD : 02/07/2020 : mis en commentaire lors du merge car il faut continuer à vérifier si il existe des ADF 
                                     * {this.state.peutDesister
                                        ?
                                        <PrimaryButton onClick={() => this._onAffichageDialogDesistement()} className="boutonReservation">Désister</PrimaryButton>
                                        :
                                        null
                                    }
                                    {this.state.peutSupprimer
                                        ?
                                        <PrimaryButton onClick={() => this._onAffichageDialogSuppressionReservation()}>Supprimer</PrimaryButton>
                                        :
                                        null
                                    }*/}
                                </div>
                            }
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-sm12 ms-xl4">
                                    <div className="ms-Grid-col ms-sm12 blocReservation niveau1">
                                        <div className="ms-Grid-row px-2">
                                            <label className="ms-Grid-col ms-sm6">Validation Eiffage</label>
                                            <Toggle className="ms-Grid-col ms-sm6"
                                                checked={reservation.validee}
                                                disabled={!objTravailAffichage.estValidationEiffageEnabled}
                                                inlineLabel
                                                offText="Non"
                                                onChange={(e, isChecked) => this._validationReservation(isChecked)}
                                                onText={reservation.dateValidation === null ? 'Oui' : `le ${Scriba.date().stringDateFormatCourt(reservation.dateValidation)}`}
                                            />
                                        </div>
                                        {objTravailAffichage.ficheKYCVisible ?
                                            <div className="ms-Grid-row px-2">
                                                <label className="ms-Grid-col ms-sm6">Fiche(s) KYC</label>
                                                <Toggle className="ms-Grid-col ms-sm6"
                                                    checked={reservation.fichesKyc}
                                                    disabled={!objTravailAffichage.fichesKYCEnabled}
                                                    inlineLabel
                                                    offText="Non fournie(s)"
                                                    onChange={this._onChangeFiche("fichesKyc")}
                                                    onText="Fournie(s)"
                                                />
                                            </div> :
                                            null
                                        }
                                        {objTravailAffichage.ficheInfoPrecontractuelleVisible ?
                                            <div className="ms-Grid-row px-2">
                                                <label className="ms-Grid-col ms-sm6">Fiche d'information précontractuelle</label>
                                                <Toggle className="ms-Grid-col ms-sm6"
                                                    checked={reservation.ficheInfoPrecontractuelle}
                                                    disabled={!objTravailAffichage.ficheInfoPrecontractuelleEnabled}
                                                    inlineLabel
                                                    offText="Non fournie"
                                                    onChange={this._onChangeFiche("ficheInfoPrecontractuelle")}
                                                    onText="Fournie"
                                                />
                                            </div> :
                                            null
                                        }
                                        <div className="ms-Grid-row px-2">
                                            <label className="ms-Grid-col ms-sm6">Validation CG</label>
                                            <Toggle className="ms-Grid-col ms-sm6"
                                                checked={reservation.estValideeCG}
                                                disabled
                                                inlineLabel
                                                offText="Non"
                                                onChange={this._onAffichageDialogConfirmationValidationDonnees}
                                                onText={`le ${Scriba.date().stringDateFormatCourt(reservation.dateValidationCG)}`}
                                            />
                                        </div>
                                        <div className="ms-Grid-row px-2">
                                            <label className="ms-Grid-col ms-sm6">Verrouillage</label>
                                            <Toggle className="ms-Grid-col ms-sm6"
                                                checked={reservation.estVerrouillee}
                                                disabled={!this.state.onActiveVerrouillageReservation || !this.state.peutModifierBlocEtat}
                                                inlineLabel
                                                offText="Non"
                                                onChange={this._onAffichageDialogConfirmationVerrouillageReservation}
                                                onText="Oui"
                                            />
                                        </div>
                                        <div className="ms-Grid-row px-2"><hr /></div>
                                        <div className="ms-Grid-row px-2">
                                            <div className="boutonEditionBlocReservation">
                                                <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichagePanelTarif()} />
                                            </div>
                                        </div>
                                        <div className="ms-Grid-row px-2">
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">Prix réservation HT :</div>
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">{reservation.prixHT != null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(reservation.prixHT.toFixed(2), false, 2) : null} €</div>
                                        </div>
                                        <div className="ms-Grid-row px-2">
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">Taux de TVA :</div>
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">{
                                                (ficheReservation.tva.length > 0 ?
                                                    Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((ficheReservation.tva[0].taux * 100).toFixed(2), false, 2) :
                                                    0)} %</div>
                                        </div>
                                        <div className="ms-Grid-row px-2">
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">Montant TVA :</div>
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">
                                                {
                                                    (reservation.prixHT != null && ficheReservation.tva.length > 0 ?
                                                        Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee((reservation.prixHT * ficheReservation.tva[0].taux).toFixed(2), false, 2) :
                                                        null)
                                                } €</div>
                                        </div>
                                        <div className="ms-Grid-row px-2">
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">Prix réservation TTC :</div>
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(prixTTC, false, 2)} €</div>
                                        </div>
                                        <div className="ms-Grid-row px-2">
                                            <div className="ms-Grid-col ms-sm12 ms-md6">En toutes lettres :</div>
                                            <div className="ms-Grid-col ms-sm12 ms-md6 labelEnToutesLettres2"><span>{Immocom.conversion().nombreEnToutesLettres(prixTTC)}</span></div>
                                        </div>
                                        <div className="ms-Grid-row px-2">
                                            <div className="ms-Grid-col ms-sm12 ms-md6">Prix maitrisé :</div>
                                            <div className="ms-Grid-col ms-sm12 ms-md6">{ficheReservation.prixMaitrise.prixMaitrise}</div>
                                        </div>
                                        <div className="ms-Grid-row px-2"><hr /></div>
                                        <div name="divEditFraisNotaire">
                                            <BlocReservation
                                                title="Frais de notaire"
                                                afficheEditButton={this.state.peutModifierBlocFraisNotaire}
                                                onEdit={() => this._onAffichagePanelFraisNotaire()}
                                                afficheSeparationPiedDeBloc
                                            >
                                                <div className="ms-Grid-row px-2">
                                                    <div className="ms-Grid-col ms-sm12 ms-md6">Frais de notaire offerts :</div>
                                                    <div className="ms-Grid-col ms-sm12 ms-md6">{(reservation.fraisNotaireOffert ? 'Oui' : 'Non')}</div>
                                                </div>
                                                <div className="ms-Grid-row px-2">
                                                    <div className="ms-Grid-col ms-sm12 ms-md6">Montant frais de notaire :</div>
                                                    <div className="ms-Grid-col ms-sm12 ms-md6">{reservation.montantFraisNotaire != null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(reservation.montantFraisNotaire, false, 2) + ' €' : null}</div>
                                                </div>
                                            </BlocReservation>
                                        </div>
                                        <div>
                                            {(this.state.peutAccederBlocDateReservation ?
                                                <div className="ms-Grid-row px-2">
                                                    <div className="boutonEditionBlocReservation">
                                                        <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichagePanelDates()} />
                                                    </div>
                                                </div>
                                                : "")}

                                            <div className="ms-Grid-row px-2">
                                                <div className="ms-Grid-col ms-sm12 ms-md6">Date de réservation :</div>
                                                <div className="ms-Grid-col ms-sm12 ms-md6">{Scriba.date().stringDateFormatCourt(reservation.dateReservation)}</div>
                                            </div>
                                            <div className="ms-Grid-row px-2">
                                                <div className="ms-Grid-col ms-sm12 ms-md6">Date de notification notaire :</div>
                                                <div className="ms-Grid-col ms-sm12 ms-md6">{Scriba.date().stringDateFormatCourt(reservation.dateNotificationNotaire)}</div>
                                            </div>
                                            <div className="ms-Grid-row px-2">
                                                <div className="ms-Grid-col ms-sm12 ms-md6">Date de signature de l'acte :</div>
                                                <div className="ms-Grid-col ms-sm12 ms-md6">{Scriba.date().stringDateFormatCourt(reservation.dateSignatureActe)}</div>
                                            </div>
                                            <div className="ms-Grid-row px-2">
                                                <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">Date de livraison :</div>
                                                <div className="ms-Grid-col ms-sm12 ms-md6 labelInfoImportante">{Scriba.date().stringDateFormatCourt(reservation.dateLivraison)}</div>
                                            </div>
                                        </div>
                                        <div className="ms-Grid-col ms-sm12"><hr /></div>
                                        {(this.state.peutAccederBlocSuiviNotaire ?
                                            <div name="divEditSuiviNotaire">
                                                <BlocReservation
                                                    title="Suivi de notaire"
                                                    afficheEditButton={this.state.peutModifierBlocSuiviNotaire}
                                                    onEdit={() => this._onAffichagePanelSuiviNotaire()}
                                                    afficheSeparationPiedDeBloc
                                                >
                                                    <div className="ms-Grid-row px-2">
                                                        <div className="ms-Grid-col ms-sm12 ms-md6">Suivi notaire :</div>
                                                        <div className="ms-Grid-col ms-sm12 ms-md6">{reservation.suiviNotaire}</div>
                                                        <div className="ms-Grid-col ms-sm12  titreBlocReservation titreBlocReservationBis">Commentaire</div>
                                                        <div className="ms-Grid-col ms-sm12 ms-md6">{reservation.suiviNotaireCommentaire}</div>
                                                    </div>
                                                </BlocReservation></div>
                                            : "")}
                                    </div>
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-xl4">
                                    <div className="ms-Grid-col ms-sm12 blocReservation niveau2">
                                        <div className="ms-Grid-col ms-sm12">
                                            <div className="boutonEditionBlocReservation">
                                                <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichageListeContacts(true, null)} />
                                            </div>
                                        </div>
                                        <div className="ms-Grid-col ms-sm12 titreBlocReservation">Acquéreur(s)</div>
                                        <div className="ms-Grid-col ms-sm12 blocContactsReservation">
                                            {contacts}
                                        </div>
                                        <div className="ms-Grid-col ms-sm12"><hr /></div>

                                        <div className="ms-Grid-col ms-sm12">
                                            <div className="boutonEditionBlocReservation">
                                                <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichageListeCommercialisateurs()} />
                                            </div>
                                        </div>
                                        <div className="ms-Grid-col ms-sm12 titreBlocReservation">Commercialisateur(s)</div>
                                        <div className="ms-Grid-col ms-sm12">{commercialisateurs}</div>
                                    </div>
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-xl4">
                                    <div className="ms-Grid-col ms-sm12 blocReservation niveau1">
                                        {/*reservation.estVerrouillee*/}
                                        {this.state.peutModifierBlocNotaire ?
                                            <div className="boutonEditionBlocReservation" name="divEditNotaire">
                                                <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichagePanelNotaire()} />
                                            </div>
                                            : null
                                        }
                                        <div className="ms-Grid-col ms-sm12 titreBlocReservation">Notaire client <span className="titreComplementBlocReservation">(si participation à la vente)</span></div>
                                        <div className="ms-Grid-col ms-sm12">Nom : {reservation.nomNotaireClient} {reservation.prenomNotaireClient}</div>
                                        <div className="ms-Grid-col ms-sm12">{reservation.adresseNotaireClient}</div>
                                        <div className="ms-Grid-col ms-sm12">{reservation.cpNotaireClient} {reservation.villeNotaireClient} {reservation.paysNotaireClient}</div>
                                        <div className="ms-Grid-col ms-sm12">Email : {reservation.emailNotaireClient}</div>
                                        <div className="ms-Grid-col ms-sm12">Tél bureau : {reservation.telNotaireClient}</div>
                                        <div className="ms-Grid-col ms-sm12">Portable : {reservation.portableNotaireClient}</div>
                                        <div className="ms-Grid-col ms-sm12"><hr /></div>

                                        {/*reservation.estVerrouillee*/}
                                        {this.state.peutModifierBlocDepotGarantie ?
                                            <div className="ms-Grid-col ms-sm12">
                                                <div className="boutonEditionBlocReservation" name="divGarantie">
                                                    <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichagePanelDepotGarantie()} />
                                                </div>
                                            </div>
                                            : null
                                        }
                                        <div className="ms-Grid-col ms-sm12 titreBlocReservation">Dépôt de garantie</div>
                                        <div className="ms-Grid-col ms-sm12">Montant du DG : {reservation.dgMontant != null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(reservation.dgMontant, false, 2) + ' €' : null}</div>
                                        <div className="ms-Grid-col ms-sm12"><Checkbox label="Chèque" checked={reservation.dgType === 'Chèque' ? true : false} disabled /></div>
                                        <div className="ms-Grid-col ms-sm12"><Checkbox label="Virement" checked={reservation.dgType === 'Virement' ? true : false} disabled /></div>
                                        <div className="ms-Grid-col ms-sm12"><hr /></div>


                                        {/*reservation.estVerrouillee*/}
                                        {this.state.peutModifierBlocConditionsParticulieres ?
                                            <div className="ms-Grid-col ms-sm12">
                                                <div className="boutonEditionBlocReservation">
                                                    <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichagePanelCommentaire()} />
                                                </div>
                                            </div>
                                            : null
                                        }
                                        <div className="ms-Grid-col ms-sm12 titreBlocReservation">Clauses spécifiques au contrat</div>
                                        <div className="ms-Grid-col ms-sm12">Conditions particulières de vente :</div>
                                        <div className="ms-Grid-col ms-sm12">{reservation.conditionsParticulieres}</div>
                                        {reservation.demandeBeneficePinel ?
                                            <React.Fragment>
                                                <div className="ms-Grid-col ms-sm12">Frais et commissions direct et indirect :</div>
                                                <div className="ms-Grid-col ms-sm6">{reservation.fraisCommissionMontant ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(reservation.fraisCommissionMontant, false, 2) : '0,00'} €</div>
                                                <div className="ms-Grid-col ms-sm6">{reservation.fraisCommissionPourcentage ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(reservation.fraisCommissionPourcentage, false, 2) : '0,00'} %</div>
                                            </React.Fragment>
                                            : null
                                        }
                                        <div className="ms-Grid-col ms-sm12  titreBlocReservation titreBlocReservationBis">Commentaires</div>
                                        <div className="ms-Grid-col ms-sm12">{reservation.remarques}</div>
                                        <div className="ms-Grid-col ms-sm12"><hr /></div>

                                        {this.state.peutModifierBlocFinancement ?
                                            <div className="ms-Grid-col ms-sm12">
                                                <div className="boutonEditionBlocReservation" name="divEditionBlocReservation">
                                                    <IconButton iconProps={{ iconName: 'Edit' }} title="Modifier" ariaLabel="Modifier" onClick={() => this._onAffichagePanelFinancement()} />
                                                </div>
                                            </div>
                                            : null
                                        }
                                        <div className="ms-Grid-col ms-sm12 titreBlocReservation">Financement</div>
                                        <div className="ms-Grid-col ms-sm12">
                                            {this.state.listFinancements.length > 0 ?
                                                <DetailsList
                                                    items={this.state.listFinancements}
                                                    selectionMode={SelectionMode.none}
                                                    columns={this.columnsListeFinancementsDeLaReservation}
                                                />
                                                :
                                                <span>Sans prêt</span>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="ms-Grid-col ms-sm12 blocReservation niveau3">
                                    <div className="ms-Grid-col ms-sm12 titreBlocReservation">Lots</div>
                                    <div className="ms-Grid-col ms-sm12">
                                        <DetailsList
                                            items={ficheReservation.listLots}
                                            columns={this.columnsLots}
                                            selectionMode={SelectionMode.none}
                                        />
                                    </div>
                                </div>
                            </div>

                            <Dialog
                                hidden={!this.state.affichageDialogDesistement}
                                onDismiss={this._onCacheDialogDesistement}
                                dialogContentProps={{
                                    type: DialogType.largeHeader,
                                    title: 'Désistement',
                                    subText: 'Veuillez renseigner une date et un motif.'
                                }}
                                modalProps={{
                                    isBlocking: true,
                                    styles: { main: { maxWidth: 450 } }
                                }}
                            >
                                <div className="ms-Grid" dir="ltr">
                                    <div className="ms-Grid-row">
                                        <div className="ms-Grid-col ms-sm12">
                                            <EUIDatePicker
                                                isRequired
                                                onSelectDate={date => Scriba.state().setObjetPropriete(this, "desistement", "dateDesistement", Scriba.date().getChaineISOFromDate(date))}
                                                placeholder="Date"
                                                value={this.state.desistement.dateDesistement}
                                            />
                                        </div>
                                        <div className="ms-Grid-col ms-sm12">
                                            <EUIComboBox
                                                label="Motif"
                                                onChange={(event, option) => Scriba.state().setObjetPropriete(this, "desistement", "motifDesistement", option.key)}
                                                options={[
                                                    { key: "Délai de rétractation légal", text: "Délai de rétractation légal" },
                                                    { key: "Refus de prêt", text: "Refus de prêt" },
                                                    { key: "Offre de prêt caduc", text: "Offre de prêt caduc" },
                                                    { key: "Autre", text: "Autre" }
                                                ]}
                                                required
                                                selectedKey={this.state.desistement.motifDesistement}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <DialogFooter>
                                    <PrimaryButton disabled={!boutonActif} onClick={() => this._onDesistementReservation()} text="Désister" />
                                    <DefaultButton onClick={this._onCacheDialogDesistement} text="Annuler" />
                                </DialogFooter>
                            </Dialog>

                            <Dialog
                                hidden={!this.state.afficheDialogSuppressionReservation}
                                onDismiss={this._onCacheDialogSuppressionReservation}
                                dialogContentProps={{
                                    type: DialogType.normal,
                                    title: 'Suppression de la réservation',
                                    subText: 'Attention, vous êtes en train de supprimer la réservation, souhaitez-vous continuer?'
                                }}
                                modalProps={{
                                    isBlocking: true,
                                    styles: { main: { maxWidth: 450 } }
                                }}
                            >
                                <DialogFooter>
                                    <PrimaryButton onClick={this._onSuppressionReservation} text="Supprimer" />
                                    <DefaultButton onClick={this._onCacheDialogSuppressionReservation} text="Annuler" />
                                </DialogFooter>
                            </Dialog>

                            <Dialog
                                hidden={!this.state.afficheDialogConfirmationVerrouillageReservation}
                                onDismiss={this._onCacheDialogConfirmationVerrouillageReservation}
                                dialogContentProps={{
                                    type: DialogType.normal,
                                    title: 'Verrouillage de la réservation',
                                    subText: `Voulez-vous ${reservation.estVerrouillee ? 'déverouiller' : 'verrouiller'} la réservation ?`
                                }}
                                modalProps={{
                                    isBlocking: true,
                                    styles: { main: { maxWidth: 450 } }
                                }}
                            >
                                <DialogFooter>
                                    <PrimaryButton onClick={() => this._verrouillageReservation(!reservation.estVerrouillee)} text="Valider" />
                                    <DefaultButton onClick={this._onCacheDialogConfirmationVerrouillageReservation} text="Annuler" />
                                </DialogFooter>
                            </Dialog>

                            <Dialog
                                hidden={!this.state.afficheDialogConfirmationValidationDonnees}
                                onDismiss={this._onCacheDialogConfirmationValidationDonnees}
                                dialogContentProps={{
                                    type: DialogType.normal,
                                    title: 'Validation des données de la réservation',
                                    subText: 'Voulez-vous valider les données de la réservation ?'
                                }}
                                modalProps={{
                                    isBlocking: true,
                                    styles: { main: { maxWidth: 450 } }
                                }}
                            >
                                <DialogFooter>
                                    <PrimaryButton onClick={() => this._validationDonneesCGReservation(!reservation.estValideeCG)} text="Valider" />
                                    <DefaultButton onClick={this._onCacheDialogConfirmationValidationDonnees} text="Annuler" />
                                </DialogFooter>
                            </Dialog>

                            <Dialog
                                hidden={!this.state.afficheDialogValidationReservation}
                                onDismiss={this._onCacheDialogValidationReservation}
                                dialogContentProps={{
                                    type: DialogType.normal,
                                    title: 'Validation de la réservation',
                                    subText: this.state.messageDialogValidationReservation
                                }}
                                modalProps={{
                                    isBlocking: true,
                                    styles: { main: { maxWidth: 450 } }
                                }}
                            >
                                <DialogFooter>
                                    <PrimaryButton onClick={this._onCacheDialogValidationReservation} text="OK" />
                                </DialogFooter>
                            </Dialog>

                            <Dialog
                                hidden={!this.state.afficheDialogValidationReservation} //afficheDialogVerrouillageReservation} YD : 06/02/2020
                                onDismiss={this._onCacheDialogValidationReservation} //_onCacheDialogVerrouillageReservation} YD : 06/02/2020
                                dialogContentProps={{
                                    type: DialogType.normal,
                                    title: 'Validation de la réservation',
                                    subText: this.state.messageDialogValidationReservation//'Veuillez valider l\'échéancier avant de verrouiller la réservation.' YD : 06/02/2020
                                }}
                                modalProps={{
                                    isBlocking: true,
                                    styles: { main: { maxWidth: 450 } }
                                }}
                            >
                                <DialogFooter>
                                    <PrimaryButton onClick={this._onCacheDialogValidationReservation} text="OK" />{/*_onCacheDialogVerrouillageReservation YD : 06/02/2020*/}
                                </DialogFooter>
                            </Dialog>
                        </div>
                        :
                        null)}

                    {(this.state.affichageFicheReservation && !ficheReservation.estChargee ?
                        <SpinnerChargement label={this.state.messageEnCoursTraitement} />
                        :
                        null)}

                    {(this.state.affichageSuiviCompteClient && this.state.peutAccederBlocSuiviCompteClient ?
                        <FicheSuiviCompteClient
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            acquereur={ficheReservation.listContacts[0]}
                            peutModifierBlocSuiviCompteClient={this.state.peutModifierBlocSuiviCompteClient}
                            peutAjouterBlocSuiviCompteClient={this.state.peutAjouterBlocSuiviCompteClient}
                            peutSupprimerBlocSuiviCompteClient={this.state.peutSupprimerBlocSuiviCompteClient}
                        /> :
                        null)}

                    {(this.state.affichageTMA && this.state.peutAccederBlocTMA ?
                        <FicheTMA
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            peutModifierBlocTMA={this.state.peutModifierBlocTMA}
                            peutAjouterBlocTMA={this.state.peutAjouterBlocTMA}
                            peutSupprimerBlocTMA={this.state.peutSupprimerBlocTMA}
                        /> :
                        null)}

                    {(this.state.affichageDemandes && this.state.peutAccederBlocDemandes ?
                        <DetailsListDemande
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                        /> :
                        null)}

                    {(this.state.affichagePanelFinancement && this.state.peutAccederBlocFinancement ?
                        <FicheFinancement
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            onAffichePanelFinancement={this.state.affichagePanelFinancement}
                            onAnnuleFiche={() => this._onCachePanelFinancement(true)}
                            onEnregistrementFiche={() => this._onCachePanelFinancement(true)}
                            peutModifierBlocFinancement={this.state.peutModifierBlocFinancement}
                            peutAjouterBlocFinancement={this.state.peutAjouterBlocFinancement}
                            peutSupprimerBlocFinancement={this.state.peutSupprimerBlocFinancement}
                        /> :
                        null)}

                    {(this.state.affichageDossierClient && this.state.peutAccederBlocDossierClient ?
                        <FicheDossierClient
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            type='Réservation'
                            peutModifierBlocDossierClient={this.state.peutModifierBlocDossierClient}
                            peutAjouterBlocDossierClient={this.state.peutAjouterBlocDossierClient}
                            //onSuppressionDossierClient={() => this._chargementReservation()} //MG - 2344
                            onChargementEtatFicheReservation={() => this._chargementReservation()}
                        /> :
                        null)}

                    {this.state.affichageEcheancier && this.state.peutAccederBlocEcheancier &&
                        <FicheReservation_Echeancier
                            estEcheancierVerrouille={reservation.echeancierValide}
                            estReservationVerrouillee={reservation.estVerrouillee}
                            idEcheancier={reservation.idEcheancier}
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            nbADFReservation={ficheReservation.nbADF}
                            onAnnuleFiche={this._onCachePanelEcheancier}
                            onEnregistrementFiche={() => this._onCachePanelEcheancier(true)}
                            peutModifierBlocEcheancier={this.state.peutModifierBlocEcheancier} //YD : 06/02/2020
                            peutModifierChoixEcheancier={this.state.peutModifierChoixEcheancier} //YD : 18/02/2020
                            peutSupprimerBlocEcheancier={this.state.peutSupprimerBlocEcheancier} //YD : 18/02/2020
                            peutVerrouillerEcheancier={this.state.peutVerrouillerEcheancier}
                            prixTTC={
                                !!reservation && !!reservation.prixHT && !!ficheReservation && ficheReservation.tva && ficheReservation.tva.length > 0
                                    ? (reservation.prixHT * (parseFloat(ficheReservation.tva[0].taux) + 1)).toFixed(2)
                                    : 0
                            }
                        />
                    }

                    {/*reservation.estVerrouillee && */}
                    {/* KP - 06/06/2023 - 2429 : bug fix (suppression impossible) */}
                    {this.state.peutAccederBlocAcquereur &&
                        <EUIPanel
                            headerText="Acquéreurs"
                            isOpen={this.state.affichagePanelAcquereurs}
                            onDismiss={this._onCacheListContacts} //MG - 2346
                            type={PanelType.large}
                        >

                            {this.state.suppressionEnCoursTraitement && <ProgressIndicatorChargement label="Suppression en cours" />}

                            <CommandBar items={[{ key: "nouveau", name: "Ajouter un contact", iconProps: { iconName: "Add" }, onClick: () => this._onAffichagePanelContact(null), disabled: !this.state.peutAjouterBlocAcquereur }]} />

                            <DetailsList
                                columns={this.columnsContacts}
                                items={ficheReservation.listContacts}
                                selectionMode={SelectionMode.none}
                            />

                            <EUIDialog
                                buttons={[
                                    <PrimaryButton key="delete" onClick={this._onSuppressionContactReservation} text="Supprimer" />,
                                    <DefaultButton key="cancel" onClick={this._onCacheDialogSuppressionContact} text="Annuler" />
                                ]}
                                isOpen={this.state.afficheDialogSuppressionContact}
                                onDismiss={this._onCacheDialogSuppressionContact}
                                titre="Suppression du contact"
                            >
                                Etes-vous certain de vouloir supprimer le contact de la réservation ?
                            </EUIDialog>

                        </EUIPanel>
                    }

                    {/*YD : 02/06/2020 - ajout test this.state.peutAccederBlocCommercialisateur */}
                    {this.state.peutAccederBlocCommercialisateur &&
                        <EUIPanel
                            headerText="Commercialisateurs"
                            isOpen={this.state.affichageCommercialisateurs}
                            onDismiss={this._onCacheListCommercialisateurs}
                            type={PanelType.large}
                        >
                            {this.state.suppressionEnCoursTraitement && <ProgressIndicatorChargement label="Suppression en cours" />}

                            {this.state.peutAjouterBlocCommercialisateur &&
                                <CommandBar items={[{ key: "nouveau", name: "Ajouter un commercialisateur", iconProps: { iconName: "Add" }, onClick: this._onAffichagePanelCommercialisateur }]} />
                            }

                            <DetailsList
                                className="containerReservation"
                                items={ficheReservation.listCommercialisateurs}
                                selectionMode={SelectionMode.none}
                                columns={this.columnsCommercialisateurs}
                            />

                            <EUIDialog
                                buttons={[
                                    <PrimaryButton key="delete" onClick={() => this._onSuppressionCommercialisateur(this.state.commercialisateurSelectionne)} text="Supprimer" />,
                                    <DefaultButton key="cancel" onClick={this._onCacheDialogSuppressionCommercialisateur} text="Annuler" />
                                ]}
                                isOpen={this.state.afficheDialogSuppressionCommercialisateur}
                                onDismiss={this._onCacheDialogSuppressionCommercialisateur}
                                titre="Suppression du commercialisateur"
                            >
                                Etes-vous certain de vouloir supprimer ce commercialisateur :<br />
                                {`${this.state.commercialisateurSelectionne.nomComplet} - ${this.state.commercialisateurSelectionne.nomSociete}`}
                            </EUIDialog>

                        </EUIPanel>
                    }

                    {(this.state.affichagePanelCommercialisateur && this.state.peutAccederBlocCommercialisateur ?
                        <FicheCommercialisation
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            idLotCommercial={ficheReservation.lotCommercial.idLotCommercial}
                            loginCompte={(this.state.commercialisateur !== undefined ? this.state.commercialisateur.loginCompte : '')}
                            onAffichePanelCommercialisateur={this.state.affichagePanelCommercialisateur}
                            onAnnuleFiche={() => this._onCachePanelCommercialisateur()}
                            onEnregistrementFiche={() => this._onRechargeLesCommercialisateurs()}
                        /> :
                        null)}

                    {(this.state.affichageFicheContact && this.state.peutAccederBlocAcquereur ?
                        <FicheContact
                            isOpen={this.state.affichageFicheContact}
                            idContact={this.state.contact.idContact}
                            onAnnuleFiche={() => this._onRechargeLesContacts()}
                            onEnregistrementFiche={() => this._onRechargeLesContacts()}
                            onEnregistrementLiaisonEntreSouhaitEtReservation={() => this._onRechargeLesContacts()}
                            pasDAccesAuxSouhaits={false}
                            pasDAccesAuxSouhaitsMaisonIndividuelle={false}
                            pasDAccesAuxDenonciations
                            pasDAccesAHistorique
                            modeSelectionDeSouhait={SelectionMode.single}
                            modeMiseAJourDuSouhaitLieAReservation
                            idReservation={this.state.idReservation}
                            idOperation={this.state.idOperation}
                            onSelectionSouhait={(e) => this._onSelectionSouhait(e)}
                            appelDepuisReservation
                        /> :
                        null)}

                    {this.state.affichagePanelFraisNotaire && this.state.peutAccederBlocFraisNotaire && (
                        <FicheFraisNotaire
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            onAffiche={this.state.affichagePanelFraisNotaire}
                            onAnnuleFiche={() => this._onCachePanelFraisNotaire()}
                            onEnregistrementFiche={() => this._onCachePanelFraisNotaire(true)}
                            peutModifier={this.state.peutModifierBlocFraisNotaire}
                        />)}

                    {(this.state.affichagePanelSuiviNotaire && this.state.peutAccederBlocSuiviNotaire ?
                        <FicheSuiviNotaire
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            onAffiche={this.state.affichagePanelSuiviNotaire}
                            onAnnuleFiche={() => this._onCachePanelSuiviNotaire()}
                            onEnregistrementFiche={() => this._onCachePanelSuiviNotaire(true)}
                            peutModifier={this.state.peutModifierBlocSuiviNotaire}
                        /> :
                        null)}

                    {(this.state.affichagePanelNotaire && this.state.peutAccederBlocNotaire ?
                        <FicheNotaire
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            onAffichePanelNotaire={this.state.affichagePanelNotaire}
                            onAnnuleFiche={() => this._onCachePanelNotaire()}
                            onEnregistrementFiche={() => this._onCachePanelNotaire(true)}
                            peutModifierBlocNotaire={this.state.peutModifierBlocNotaire}
                        /> :
                        null)}

                    {(this.state.affichagePanelDepotGarantie && this.state.peutAccederBlocDepotGarantie ?
                        <FicheDepotGarantie
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            onAffichePanelDepotGarantie={this.state.affichagePanelDepotGarantie}
                            onAnnuleFiche={() => this._onCachePanelDepotGarantie()}
                            onEnregistrementFiche={() => this._onCachePanelDepotGarantie(true)}
                            peutModifierBlocDepotGarantie={this.state.peutModifierBlocDepotGarantie}
                        /> :
                        null)}

                    {(this.state.affichagePanelCommentaire && this.state.peutAccederBlocConditionsParticulieres ?
                        <FicheCommentaire
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            onAffichePanelCommentaire={this.state.affichagePanelCommentaire}
                            onAnnuleFiche={() => this._onCachePanelCommentaire()}
                            onEnregistrementFiche={() => this._onCachePanelCommentaire(true)}
                            peutModifierBlocConditionsParticulieres={this.state.peutModifierBlocConditionsParticulieres}
                        /> :
                        null)}

                    {(this.state.affichagePanelDates && this.state.peutAccederBlocDateReservation ?
                        <FicheCalendrierReservation
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            idLotCommercial={this.state.idLotCommercial}
                            onAffichePanelCalendrierReservation={this.state.affichagePanelDates}
                            onAnnuleFiche={() => this._onCachePanelDates()}
                            onEnregistrementFiche={() => this._onCachePanelDates(true)}
                            peutModifierBlocDateReservation={this.state.peutModifierBlocDateReservation}
                        /> :
                        null)}

                    {(this.state.affichagePanelTarif && this.state.peutAccederBlocPrix ?
                        <FicheTarifReservation
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            reservation={ficheReservation.reservation}
                            listeDesTVAs={ficheReservation.listTVA}
                            onAffichePanelTarifReservation={this.state.affichagePanelTarif}
                            onAnnuleFiche={() => this._onCachePanelTarif()}
                            onEnregistrementFiche={() => this._onCachePanelTarif(true)}
                            peutModifierBlocPrix={this.state.peutModifierBlocPrix}
                            peutAjouterBlocPrix={this.state.peutAjouterBlocPrix}
                            peutSupprimerBlocPrix={this.state.peutSupprimerBlocPrix}
                        /> :
                        null)}

                    {(this.state.affichagePanelCycle ?
                        <FicheReservationCycle
                            idOperation={this.state.idOperation}
                            idReservation={this.state.idReservation}
                            idLotCommercial={this.state.idLotCommercial}
                            nbADF={ficheReservation.nbADF}
                            affichageSignatureClient={this.state.affichageSignatureClient}
                            affichageValidationEiffage={this.state.affichageValidationEiffage}
                            affichageSignatureEiffage={this.state.affichageSignatureEiffage}
                            affichageSignatureActe={this.state.affichageSignatureActe}
                            onAffichePanelReservationCycle={this.state.affichagePanelCycle}
                            onAnnuleFiche={() => this._onCachePanelCycle()}
                            onEnregistrementFiche={() => this._onCachePanelCycle()}
                        /> :
                        null)}


                    <FicheChecklistItems_Reservation
                        idOperation={this.state.idOperation}
                        idReservation={this.state.idReservation}
                        isOpen={this.state.affichageChecklist}
                        onDismiss={() => this.setState({ affichageChecklist: false })}
                    />

                </Stack>

            </Panel>;
        }
    }

    constructor(props) {
        super(props);

        this._selectionSouhait = new Selection({
            onSelectionChanged: () => {
                const selectionCount = this._selectionSouhait.getSelectedCount();

                if (selectionCount === 1) {
                    let contactTrav = { ...this.state.contact };
                    contactTrav.idSouhait = this._selectionSouhait.getSelection()[0].idSouhait;
                    contactTrav.souhait = this._selectionSouhait.getSelection()[0];

                    this.setState({ contact: contactTrav });
                }
            }
        });

        //Selection des contacts à retirer de la réservation (uniquement en création)
        this._selectionContactARetirer = new Selection({
            onSelectionChanged: () => {
                let selectionEnCours = [];

                this._selectionContactARetirer.getSelection().forEach(function (contact) {
                    selectionEnCours.push(contact);
                });

                this.setState({ selectionContacts: selectionEnCours });
            }
        });

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    //#region VerificationFormulaire
    _onVerificationFormulaireContact() {
    }
    _onVerificationFormulaireEcheancier() {
    }
    _onVerificationFormulaireCommercialisateur() {
        Immocom.fiche()._validationFormulaire(this, 'Commercialisation', this.state.listCommercialisateurs, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }
    _onVerificationFormulaireTarifReservation() {
        Immocom.fiche()._validationFormulaire(this, 'TarifReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }
    _onVerificationFormulaireCalendrierReservation() {
        Immocom.fiche()._validationFormulaire(this, 'CalendrierReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }
    _onVerificationFormulaireCommentaireReservation() {
        Immocom.fiche()._validationFormulaire(this, 'CommentaireReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onChargementDesColumnsDesTableaux() {
        //#region Chargement des columns des contacts
        let columnsTempListeContacts = [];

        columnsTempListeContacts.push({
            key: 'nom', name: 'Nom', fieldName: 'nom', minWidth: 100, maxWidth: 150
        });

        columnsTempListeContacts.push({
            key: 'prenom', name: 'Prénom', fieldName: 'prenom', minWidth: 50, maxWidth: 100
        });

        columnsTempListeContacts.push({
            key: 'cp', name: 'CP', fieldName: 'cp', minWidth: 50, maxWidth: 50,
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
        });

        columnsTempListeContacts.push({
            key: 'ville', name: 'Ville', fieldName: 'ville', minWidth: 100, maxWidth: 150,
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
        });

        columnsTempListeContacts.push({
            key: 'tel1', name: 'Téléphone', fieldName: 'tel1', minWidth: 100, maxWidth: 150,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
        });

        columnsTempListeContacts.push({
            key: 'regionAdministrative', name: 'Région Adm.', fieldName: 'regionAdministrative', minWidth: 100, maxWidth: 150,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                return <span> {item.regionAdministrative}</span>;
            }
        });

        columnsTempListeContacts.push({
            key: 'departementAdministratif', name: 'Dép. Adm.', fieldName: 'departementAdministratif', minWidth: 100, maxWidth: 150,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                return <span>{item.departementAdministratif}</span>;
            }
        });

        columnsTempListeContacts.push({
            key: 'villeAdministrative', name: 'Ville Adm.', fieldName: 'villeAdministrative', minWidth: 100, maxWidth: 150,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                return <span>{item.villeAdministrative}</span>;
            }
        });

        columnsTempListeContacts.push({
            key: 'nomCommercial', name: 'Opération', fieldName: 'nomCommercial', minWidth: 100, maxWidth: 150,
            className: 'ms-hiddenSm',
            headerClassName: 'ms-hiddenSm',
            onRender: (item) => {
                return <span>{item.nomCommercial}</span>;
            }
        });

        columnsTempListeContacts.push({
            key: 'type', name: 'Type', fieldName: 'type', minWidth: 75, maxWidth: 100,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                return <span>{item.nature}</span>;
            }
        });

        columnsTempListeContacts.push({
            key: 'nbPieces', name: 'Nbre pièces', fieldName: 'nbPieces', minWidth: 25, maxWidth: 50,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                return (item.souhait !== undefined ? <span>{item.souhait.rechercheNombrePiece}</span> : null);
            }
        });

        if (this.state.peutModifierBlocAcquereur) {
            columnsTempListeContacts.push({
                key: 'edition', name: '', fieldName: 'edition', minWidth: 25, maxWidth: 25,
                onRender: (item) => {
                    return <Icon title="Modifier le contact" iconName="Edit" className="iconeEdition" onClick={() => this._onAffichagePanelContact(item.idContact)} />;
                }
            });
        }

        if (this.state.peutSupprimerBlocAcquereur && this.state.ficheReservation.listContacts.length > 1) {
            columnsTempListeContacts.push({
                key: 'suppression', name: '', fieldName: 'suppression', minWidth: 25, maxWidth: 25,
                onRender: (item) => {
                    // La réservation doit avoir au moins 1 contact
                    return <Icon title="Supprimer le contact" iconName="Delete" className="iconeSuppression" onClick={() => this._onAffichageDialogSuppressionContact(item.idContact)} />;
                }
            });
        }

        this.columnsContacts = columnsTempListeContacts;
        //#endregion

        //#region Chargement des columns des souhaits
        let columnsTempListeSouhaits = [];

        columnsTempListeSouhaits.push({
            key: 'motifAcquisition', name: 'Motif d\'acquisition', fieldName: 'rechercheMotifAcquisition', minWidth: 100, maxWidth: 200
        });

        columnsTempListeSouhaits.push({
            key: 'region', name: 'Région', fieldName: 'regionAdministrative', minWidth: 100, maxWidth: 200
        });

        columnsTempListeSouhaits.push({
            key: 'departement', name: 'Département', fieldName: 'departementAdministratif', minWidth: 100, maxWidth: 200
        });

        columnsTempListeSouhaits.push({
            key: 'ville', name: 'Ville', fieldName: 'rechercheVille', minWidth: 100, maxWidth: 200
        });

        columnsTempListeSouhaits.push({
            key: 'typeLogement', name: 'Type de logement', fieldName: 'nature', minWidth: 100, maxWidth: 200
        });

        columnsTempListeSouhaits.push({
            key: 'nbPieces', name: 'Nb de pièces', fieldName: 'rechercheNombrePiece', minWidth: 50, maxWidth: 50
        });

        columnsTempListeSouhaits.push({
            key: 'budgetAcquisition', name: 'Budget acquisition', fieldName: 'rechercheBudgetAcquisition', minWidth: 100, maxWidth: 200,
            onRender: (item) => {
                return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.rechercheBudgetAcquisition, false, 2)} €</span>;
            }
        });

        columnsTempListeSouhaits.push({
            key: 'apportPersonnel', name: 'Apport personnel', fieldName: 'rechercheApportPersonnel', minWidth: 100, maxWidth: 200,
            onRender: (item) => {
                return <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.rechercheApportPersonnel, false, 2)} €</span>;
            }
        });

        columnsTempListeSouhaits.push({
            key: 'prochaineAction', name: 'Prochaine action', fieldName: 'rechercheDateRDV1', minWidth: 100, maxWidth: 200,
            onRender: (item) => {
                return <span>{Scriba.date().stringDateFormatCourt(item.rechercheDateRDV1)}</span>;
            }
        });

        columnsTempListeSouhaits.push({
            key: 'edition', name: '', fieldName: 'edition', minWidth: 25, maxWidth: 25,
            onRender: (item) => {
                return <Icon title="Modifier le souhait" iconName="Edit" className="iconeSuppression" onClick={() => this._onAffichagePanelSouhait(item.idContact, item.idSouhait)} />;
            }
        });

        this.columnsSouhaits = columnsTempListeSouhaits;
        //#endregion

        //#region Chargement des columns des financements
        let columnsTempListeFinancementsDeLaReservation = [];

        columnsTempListeFinancementsDeLaReservation.push({
            key: 'naturePret',
            name: 'Nature du prêt',
            fieldName: 'naturePret',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onRender: (item) => {
                return <div className="labelStadeEcheancier">{item.naturePret}</div>;
            }
        });

        columnsTempListeFinancementsDeLaReservation.push({
            key: 'montantTotalMax',
            name: 'Montant total maximum',
            fieldName: 'montantTotalMax',
            minWidth: 100,
            maxWidth: 200,
            isResizable: true,
            onRender: (item) => {
                return (item.montantTotalMax !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.montantTotalMax, false, 2)} €</span> : null);
            }
        });

        columnsTempListeFinancementsDeLaReservation.push({
            key: 'dureeMinimale',
            name: 'Durée minimale en années',
            fieldName: 'dureeMinimale',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return (item.dureeMinimale !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.dureeMinimale, false, 0)} ans</span> : null);
            }
        });

        columnsTempListeFinancementsDeLaReservation.push({
            key: 'tauxEffectifGlobalAnnuelMax',
            name: 'Taux effectif global annuel maximum (% par an)',
            fieldName: 'tauxEffectifGlobalAnnuelMax',
            minWidth: 100,
            maxWidth: 150,
            isResizable: true,
            headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return (item.tauxEffectifGlobalAnnuelMax !== null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.tauxEffectifGlobalAnnuelMax, false, 3)} %</span> : null);
            }
        });

        this.columnsListeFinancementsDeLaReservation = columnsTempListeFinancementsDeLaReservation;
        //#endregion

        //#region Chargement des columns des lots
        let columnsTempListeLots = [];

        columnsTempListeLots.push({
            key: 'numeroLot', name: 'N° lot', fieldName: 'numeroLot', minWidth: 100, maxWidth: 100
        });

        columnsTempListeLots.push({
            key: 'lotType', name: 'Type', fieldName: 'lotType', minWidth: 100, maxWidth: 100
        });

        columnsTempListeLots.push({
            key: 'nature', name: 'Nature', fieldName: 'nature', minWidth: 100, maxWidth: 100, headerClassName: 'ms-hiddenMdDown', className: 'ms-hiddenMdDown'
        });

        columnsTempListeLots.push({
            key: 'numCoPro', name: 'N° copro', fieldName: 'numCoPro', minWidth: 50, maxWidth: 50, headerClassName: 'ms-hiddenLgDown', className: 'ms-hiddenLgDown'
        });

        columnsTempListeLots.push({
            key: 'nombreTantiemes', name: 'Nb tantièmes', fieldName: 'nombreTantiemes', minWidth: 50, maxWidth: 50, headerClassName: 'ms-hiddenLgDown', className: 'ms-hiddenLgDown'
        });

        columnsTempListeLots.push({
            key: 'baseTantiemes', name: 'Base tantièmes', fieldName: 'baseTantiemes', minWidth: 50, maxWidth: 50, headerClassName: 'ms-hiddenLgDown', className: 'ms-hiddenLgDown'
        });

        columnsTempListeLots.push({
            key: 'exposition', name: 'Expo.', fieldName: 'exposition', minWidth: 30, maxWidth: 30, headerClassName: 'ms-hiddenLgDown', className: 'ms-hiddenLgDown'
        });

        columnsTempListeLots.push({
            key: 'batiment', name: 'Bât.', fieldName: 'batiment', minWidth: 30, maxWidth: 30, headerClassName: 'ms-hiddenLgDown', className: 'ms-hiddenLgDown'
        });

        columnsTempListeLots.push({
            key: 'surface', name: 'Surface', fieldName: 'surface', minWidth: 50, maxWidth: 50, headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
            onRender: (item) => {
                return (item.surfaceHabitable != null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.surfaceHabitable, false, 2)} m²</span> : null);
            }
        });

        columnsTempListeLots.push({
            key: 'etage', name: 'Etage', fieldName: 'etage', minWidth: 40, maxWidth: 40, headerClassName: 'ms-hiddenLgDown',
            className: 'ms-hiddenLgDown',
        });

        columnsTempListeLots.push({
            key: 'prixHT', name: 'Prix HT', fieldName: 'prixHT', minWidth: 100, maxWidth: 150, headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return (item.prixHT != null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.prixHT, false, 2)} €</span> : null);
            }
        });

        columnsTempListeLots.push({
            key: 'prixMaitriseHT', name: 'Prix maitrisé HT', fieldName: 'prixMaitriseHT', minWidth: 100, maxWidth: 150, headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return (item.prixMaitriseHT != null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.prixMaitriseHT, false, 2)} €</span> : null);
            }
        });

        columnsTempListeLots.push({
            key: 'prixMobilierHT', name: 'Prix mobilier HT', fieldName: 'prixMobilierHT', minWidth: 100, maxWidth: 150, headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return (item.prixMobilierHT != null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.prixMobilierHT, false, 2)} €</span> : null);
            }
        });

        columnsTempListeLots.push({
            key: 'loyerAnnuelHT', name: 'Loyer annuel HT', fieldName: 'loyerAnnuelHT', minWidth: 100, maxWidth: 150, headerClassName: 'ms-hiddenXlDown',
            className: 'ms-hiddenXlDown',
            onRender: (item) => {
                return (item.loyerAnnuelHT != null ? <span>{Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(item.loyerAnnuelHT, false, 2)} €</span> : null);
            }
        });

        this.columnsLots = columnsTempListeLots;
        //#endregion

        //#region Chargement des columns des commercialisateurs
        let columnsTempCommercialisateurs = [];

        columnsTempCommercialisateurs.push({
            key: 'societe', name: 'Société', fieldName: 'societe', minWidth: 70, maxWidth: 350,
            onRender: (item) => {
                return <span>{item.nomSociete}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'nom', name: 'Nom', fieldName: 'nom', minWidth: 70, maxWidth: 350,
            onRender: (item) => {
                return <span>{item.nomComplet}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'tel', name: 'Tel', fieldName: 'tel', minWidth: 100, maxWidth: 200, headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',

            onRender: (item) => {
                return <span>{item.tel}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'honoraires', name: 'Honoraires', fieldName: 'honoraires', minWidth: 100, maxWidth: 200, headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                let honorairesReel = (item.honoraireReel ? item.honoraireReel : item.honoraireReelNombre);                
                //return <span>{(honorairesReel ? `${Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(honorairesReel, false, 2)} €` : 'Aucune donnée saisie')}</span>;
                let honorairesText = ''; //MG - 2335/2239
                if (honorairesReel) {
                    if (honorairesReel.includes('%')) {
                        honorairesText = honorairesReel;
                    } else {
                        honorairesText = `${Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(honorairesReel, false, 2)} €`;
                    }
                } else {
                    honorairesText = 'Aucune donnée saisie';
                }
                return <span>{honorairesText}</span>;
            }
        });

        columnsTempCommercialisateurs.push({
            key: 'login', name: 'Login', fieldName: 'login', minWidth: 200, maxWidth: 350, headerClassName: 'ms-hiddenMdDown',
            className: 'ms-hiddenMdDown',
            onRender: (item) => {
                return <span>{item.loginCompte}</span>;
            }
        });

        if (this.state.peutModifierBlocCommercialisateur) {
            columnsTempCommercialisateurs.push({
                key: 'edition', name: '', fieldName: 'edition', minWidth: 20, maxWidth: 20,
                onRender: (item) => {
                    return <Icon title="Modifier le commercialisateur" iconName="Edit" className="iconeEdition" onClick={() => this._onAffichagePanelCommercialisateur(item)} />;
                }
            });
        }
        if (this.state.peutSupprimerBlocCommercialisateur && (this.state.ficheReservation.listCommercialisateurs.length > 1 || this.state.listCommercialisateurs.length > 1)) {
            columnsTempCommercialisateurs.push({
                key: 'suppression', name: '', fieldName: 'suppression', minWidth: 20, maxWidth: 20,
                onRender: (item) => {
                    return <Icon title="Supprimer le commercialisateur" iconName="Delete" className="iconeSuppression" onClick={() => this._onAffichageDialogSuppressionCommercialisateur(item)} />;
                }
            });
        }

        this.columnsCommercialisateurs = columnsTempCommercialisateurs;
        //#endregion
    }
    _onChangeCommentaire(tablValeurModifiee) {
        for (let i = 0; i < tablValeurModifiee.length; i++) {
            if (i == tablValeurModifiee.length - 1)
                Scriba.state().setObjetPropriete(this, "reservation", tablValeurModifiee[i][0], tablValeurModifiee[i][1], this._onVerificationFormulaireCommentaireReservation);
            else
                Scriba.state().setObjetPropriete(this, "reservation", tablValeurModifiee[i][0], tablValeurModifiee[i][1]);
        }
    }
    //#endregion

    //#region Actions
    _onAjouteContactALaListeDesContacts = (contact, listeDesContacts) => {
        //Ajoute le contact à la liste, le remplace s'il existe deja
        let element = listeDesContacts.find(c => c.idContact === contact.idContact);
        let index = listeDesContacts.indexOf(element);

        if (index !== -1) {
            listeDesContacts.splice(index, 1);
        }

        listeDesContacts.push(contact);
    }

    _onEnregistrementCreation = () => {
        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Enregistrement de la réservation' });

        let _onEnregistrementCreation = DataReservation._onEnregistrementCreation(this.state.idOperation, 0, this.props.idLotCommercial, this.state.reservation, this.state.listContacts, this.state.listCommercialisateurs);

        _onEnregistrementCreation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._onAnnulation();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }
    _onEnregistrementValidation() {
        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: 'Enregistrement en cours' });

        let miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.ficheReservation.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    //this._chargementReservationSimple();
                    this._chargementReservation(); // CB - Il faut recharger la fiche entière pour màj la timeline
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _validationDonneesCGReservation(onValide) {
        this._onCacheDialogConfirmationValidationDonnees();
        this._majStateValidationCGReservation(onValide, () => this._onEnregistrementValidation());
    }

    _onSuppressionReservation = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Suppression de la réservation'
        });

        let _onSuppressionReservation = DataReservation._onSuppressionReservation(this.state.idOperation, this.state.idReservation);

        _onSuppressionReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._onAnnulation();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onSuppressionContactReservation = () => {
        const { idOperation, idReservation } = this.props;
        const { idContactSelectionne } = this.state;

        this.setState({ afficheDialogSuppressionContact: false, suppressionEnCoursTraitement: true });

        DataReservation._onSuppressionContactReservation(idOperation, idReservation, idContactSelectionne).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                this.setState({ suppressionEnCoursTraitement: false });
                this._onRechargeLesContacts();
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    };

    _onSuppressionCommercialisateur = (commercialisateur) => {

        const { idOperation, idReservation } = this.props;
        const { loginCompte } = commercialisateur;

        if (!idReservation) {
            let listCommercialisateurs = [...this.state.listCommercialisateurs];

            const element = listCommercialisateurs.find(c => c.loginCompte === loginCompte);
            const index = listCommercialisateurs.indexOf(element);
            listCommercialisateurs.splice(index, 1);

            this.setState({
                afficheDialogSuppressionCommercialisateur: false,
                listCommercialisateurs
            });
        }
        else {
            this.setState({ afficheDialogSuppressionCommercialisateur: false, suppressionEnCoursTraitement: true });
            DataReservation._onSuppressionCommercialisation(idOperation, idReservation, loginCompte).then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    this.setState({ suppressionEnCoursTraitement: false });
                    this._onRechargeLesCommercialisateurs(true);
                }
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });
        }
    };

    _onSuppressionContactDeLaSelection = () => {
        var nouvelleListeDeContacts = [...this.state.listContacts];

        this.state.selectionContacts.forEach(function (contactARetirer) {
            let element = nouvelleListeDeContacts.find(d => d.idContact === contactARetirer.idContact);
            let i = nouvelleListeDeContacts.indexOf(element);

            nouvelleListeDeContacts.splice(i, 1);
        });

        this.setState({
            afficheDialogSuppressionContact: false,
            listContacts: nouvelleListeDeContacts,
            selectionContacts: []
        });
    }

    _onDesistementReservation = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Désistement de la réservation'
        });

        let onDesistementReservation = DataReservation._onDesistementReservation(this.state.idOperation, this.state.idReservation, this.state.desistement);

        onDesistementReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._onAnnulation();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }
    _validationFormulaireDesistement(item) {
        let estValide = false;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            let typeEnregistrement = 'Création';
            var validationFormulaire = Data._onValidationFormulaire('ReservationDesistee', item, typeEnregistrement);

            validationFormulaire
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif !== null) {
                        estValide = false;
                    }
                    else {
                        estValide = true;
                    }

                    if (this.state.onActiveBoutonEnregistrerDesistement !== estValide) {
                        this.setState({ onActiveBoutonEnregistrerDesistement: estValide });
                    }
                });
        }
    }

    _onChangeFiche = (fiche) => (e, isChecked) => {
        this.setState(prevState => {
            let ficheReservation = { ...prevState.ficheReservation };
            let reservation = {
                ...ficheReservation.reservation,
                [fiche]: isChecked
            };
            if (!isChecked && new Date(reservation.dateReservation) >= new Date(2021, 2, 1)) {
                reservation.validee = false;
                reservation.dateDeSignatureEiffageManuelle = null;
            }
            ficheReservation.reservation = reservation;
            return { ficheReservation };
        }, this._onEnregistrementValidation);
    };

    _verrouillageReservation = (onValide) => {
        this._onCacheDialogConfirmationVerrouillageReservation(); // KP (26/02/2020) : On masque la dialog quoiqu'il arrive
        if (onValide) {
            if (!this.state.ficheReservation.reservation.echeancierValide) {
                this._onAffichageDialogValidationReservation('Veuillez valider l\'échéancier avant de verrouiller la réservation.');//YD : 06/02/2020
            }
            else {
                this._majStateVerrouillageReservation(true, () => this._onEnregistrementValidation());
            }
        }
        else {
            let nbADFEmis = this.state.ficheReservation.nbADF;

            if (nbADFEmis > 0) {
                if (nbADFEmis === 1) {
                    this._onAffichageDialogValidationReservation('1 avancement travaux a déjà été posé pour cette réservation. Veuillez le supprimer avant de déverrouiller la réservation.');
                }
                else {
                    this._onAffichageDialogValidationReservation(nbADFEmis + ' avancements travaux ont déjà été posés pour cette réservation. Veuillez les supprimer avant de déverrouiller la réservation.');
                }
            }
            else {
                this._majStateVerrouillageReservation(false, () => this._onEnregistrementValidation());
            }
        }
    }

    _validationReservation(onValide) {
        if (onValide) {
            // si résa validée => activation des ctrls 'Verouillee' et 'BonASignerEiffage' 
            this.setState(state => {
                state.ficheReservation.reservation.validee = true;
                state.ficheReservation.reservation.dateValidation = new Date();
                state.onActiveVerrouillageReservation = true;
                return state;
            }, function () {
                this._onEnregistrementValidation();
            });
        }
        else {
            if (this.state.ficheReservation.existeDocumentsSigneEiffage) {
                this._onAffichageDialogValidationReservation('Vous ne pouvez pas dévalider cette réservation car il existe un contrat signé.');
            }
            else {
                let nbADFEmis = this.state.ficheReservation.nbADF;

                if (nbADFEmis > 0) {
                    if (nbADFEmis === 1) {
                        this._onAffichageDialogValidationReservation('1 avancement travaux a déjà été posé pour cette réservation. Veuillez le supprimer avant de dévalider la réservation.');
                    }
                    else {
                        this._onAffichageDialogValidationReservation(nbADFEmis + ' avancements travaux ont déjà été posés pour cette réservation. Veuillez les supprimer avant de dévalider la réservation.');
                    }
                }
                else {
                    // si résa dévalidée : on désactive la réservation + désactive les ctrls 'Verouillee' et 'BonASignerEiffage' + décoche les ctrls 'Verouillee' et 'BonASignerEiffage'
                    this.setState(state => {
                        state.ficheReservation.reservation.validee = false;
                        state.ficheReservation.reservation.estVerrouillee = false;
                        state.onActiveVerrouillageReservation = false;
                        return state;
                    }, function () {
                        this._onEnregistrementValidation();
                    });
                }
            }
        }
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheReservation();
    }
    //#endregion

    //#region Affichage et Masquage
    _onAffichageListeContacts = (onAfficheDansUnPanel, contact) => {

        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);

        if (onAfficheDansUnPanel) {//Modification
            stateTemp.affichagePanelAcquereurs = true;
            stateTemp.affichageFicheReservation = true;
            stateTemp.listContacts = this.state.listContacts;
        }
        else {
            let listContacts = [...this.state.listContacts];

            if (contact !== null) {
                this._onAjouteContactALaListeDesContacts(contact, listContacts);
            }
            stateTemp.affichageSectionContacts_ModeCreation = true;
            stateTemp.listContacts = listContacts;
        }

        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    };
    _onAffichageListeCommercialisateurs = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichageCommercialisateurs = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    };
    _onAffichageReservationTarifs() {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichageSectionReservationTarifs_ModeCreation = true;

        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichageReservationDates() {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichageSectionReservationDates_ModeCreation = true;

        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichageReservationCommentaire() {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichageSectionReservationCommentaire_ModeCreation = true;

        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }

    _onAffichagePanelContact = (idContact) => {
        const contact = { ...this.state.contact, idContact };
        let state = {};
        this._onCacheTout(state);
        state.contact = contact;
        state.affichageFicheContact = true;
        state.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
    };

    _onAffichagePanelSouhait = (contact, idSouhait) => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.contact = contact;
        stateTemp.idSouhait = idSouhait;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelCommercialisateur = (commercialisateur) => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.commercialisateur = commercialisateur;
        //stateTemp.affichageCommercialisateurs = true;
        stateTemp.affichagePanelCommercialisateur = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelNotaire = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelNotaire = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelDepotGarantie = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelDepotGarantie = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelFinancement = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelFinancement = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelCommentaire = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelCommentaire = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelDates = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelDates = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelTarif = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelTarif = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }

    _onAffichagePanelSuiviNotaire = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelSuiviNotaire = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelFraisNotaire = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichagePanelFraisNotaire = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onAffichagePanelCycle = (etat) => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichageFicheReservation = true;
        switch (etat) {
            case 20: //Signée client
                stateTemp.affichagePanelCycle = true;
                stateTemp.affichageSignatureClient = true;
                stateTemp.affichageValidationEiffage = false;
                stateTemp.affichageSignatureEiffage = false;
                stateTemp.affichageSignatureActe = false;
                break;
            case 30: //Validée Eiffage
                stateTemp.affichagePanelCycle = true;
                stateTemp.affichageSignatureClient = true;
                stateTemp.affichageValidationEiffage = true;
                stateTemp.affichageSignatureEiffage = false;
                stateTemp.affichageSignatureActe = false;
                break;
            case 35: //Signée Eiffage
                stateTemp.affichagePanelCycle = true;
                stateTemp.affichageSignatureClient = true;
                stateTemp.affichageValidationEiffage = true;
                stateTemp.affichageSignatureEiffage = true;
                stateTemp.affichageSignatureActe = false;
                break;
            case 40: //Actée
                stateTemp.affichagePanelCycle = true;
                stateTemp.affichageSignatureClient = true;
                stateTemp.affichageValidationEiffage = true;
                stateTemp.affichageSignatureEiffage = true;
                stateTemp.affichageSignatureActe = true;
                break;
            default:
                stateTemp.affichagePanelCycle = false;
                stateTemp.affichageSignatureClient = false;
                stateTemp.affichageValidationEiffage = false;
                stateTemp.affichageSignatureEiffage = false;
                stateTemp.affichageSignatureActe = false;
                break;
        }

        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }

    _onCacheListContacts = () => {
        let state = {};
        this._onCacheTout(state);
        state.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
    };

    _onCacheListCommercialisateurs = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    }
    _onCachePanelContact = () => {
        let contactTrav = { ...this.state.contact };
        contactTrav.idContact = null;
        let stateTemp = { ...this.state };
        stateTemp.contact = contactTrav;
        this._onCacheTout(stateTemp);
        stateTemp.affichageSectionContacts_ModeCreation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    };
    _onCachePanelCommercialisateur = () => {
        let stateTemp = { ...this.state };
        this._onCacheTout(stateTemp);
        stateTemp.affichageCommercialisateurs = true;
        stateTemp.affichageFicheReservation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
    };
    _onCachePanelCommercialisateurEtAjoutDuCommercialisateurEnModeCreationDeReservation = (listCommercialisateur) => {

        let listCommercialisateursTrav = [];

        if (this.props.idReservation === 0 || this.props.idReservation == null) {
            listCommercialisateursTrav = [...this.state.listCommercialisateurs];
            let commercialisateur = listCommercialisateur[0];

            // On vérifie qu'il n'est pas déjà dans la liste
            if (listCommercialisateursTrav.length === 0) {
                listCommercialisateursTrav.push(commercialisateur);
            }
            else {
                listCommercialisateursTrav = listCommercialisateursTrav.filter(e => e.loginCompte !== commercialisateur.loginCompte);
                listCommercialisateursTrav.push(commercialisateur);
            }

            let stateTemp = {};
            this._onCacheTout(stateTemp);
            stateTemp.affichageCommercialisateurs = true;
            stateTemp.listCommercialisateurs = listCommercialisateursTrav;

            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp, false, this._onVerificationFormulaireCommercialisateur);

            this._onChargementDesColumnsDesTableaux();
        }
    };



    _onCachePanelEcheancier = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            this._chargementReservation(false, false, true);
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };
    _onCachePanelNotaire = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            this._chargementReservationSimple();
            //this._chargementReservation();
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };
    _onCachePanelDepotGarantie = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            this._chargementReservationSimple();
            //this._chargementReservation();
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };
    _onCachePanelFinancement = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            this._chargementFinancement();
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };
    _onCachePanelCommentaire = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            this._chargementReservationSimple();
            //this._chargementReservation();
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };
    _onCachePanelDates = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            //this._chargementReservationSimple();
            this._chargementReservation(); // CB - Il faut recharger la fiche entière pour màj la timeline
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };
    _onCachePanelTarif = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            //this._chargementReservationSimple();
            this._chargementReservation(); //AF - Le chargement de reservation simple ne charge que l'objet réservation, or la TVA n'est pas incluse dans l'objet réservation
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };
    _onCachePanelFraisNotaire = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            this._chargementReservationSimple();
            //this._chargementReservation();
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };

    _onCachePanelSuiviNotaire = (onRechargeLaReservation) => {
        if (onRechargeLaReservation) {
            this._onCacheTout();
            this._chargementReservationSimple();
            //this._chargementReservation();
        }
        else {
            let stateTemp = { ...this.state };
            this._onCacheTout(stateTemp);
            stateTemp.affichageFicheReservation = true;
            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
        }
    };

    _onCachePanelCycle = () => {
        this._onCacheTout();
        //this._chargementReservationSimple();
        this._chargementReservation();
    };
    _onCacheTout = (stateTemp) => {
        if (stateTemp != undefined) {
            stateTemp.affichageSectionContacts_ModeCreation = false;
            stateTemp.affichageSectionReservationTarifs_ModeCreation = false;
            stateTemp.affichageSectionReservationDates_ModeCreation = false;
            stateTemp.affichageSectionReservationEcheancier_ModeCreation = false;
            stateTemp.affichageSectionReservationCommentaire_ModeCreation = false;

            stateTemp.affichageFicheContact = false;
            stateTemp.affichageCommercialisateurs = false;
            stateTemp.affichageOngletDesSouhaits = false;
            stateTemp.affichageFicheReservation = false;
            stateTemp.affichageAcquereur = false;
            stateTemp.affichageCommercialisateur = false;
            stateTemp.affichageConditionsParticulieres = false;
            stateTemp.affichageDateAutre = false;
            stateTemp.affichageDateReservation = false;
            stateTemp.affichageDepotGarantie = false;
            stateTemp.affichageDossierClient = false;
            stateTemp.affichageEcheancier = false;
            stateTemp.affichageEtat = false;
            stateTemp.affichageLot = false;
            stateTemp.affichageNotaireClient = false;
            stateTemp.affichagePrix = false;
            stateTemp.affichageSuiviCompteClient = false;
            stateTemp.affichageTMA = false;
            stateTemp.affichageDemandes = false;
            stateTemp.affichageCh = false;

            stateTemp.affichagePanelAcquereurs = false;
            stateTemp.affichagePanelCommercialisateur = false;
            stateTemp.affichagePanelNotaire = false;
            stateTemp.affichagePanelDepotGarantie = false;
            stateTemp.affichagePanelCommentaire = false;
            stateTemp.affichagePanelTarif = false;
            stateTemp.affichagePanelDates = false;
            stateTemp.affichagePanelFinancement = false;
            stateTemp.affichagePanelCycle = false;
            stateTemp.affichagePanelFraisNotaire = false;
            stateTemp.affichagePanelSuiviNotaire = false;

            stateTemp.affichageSignatureClient = false;
            stateTemp.affichageValidationEiffage = false;
            stateTemp.affichageSignatureEiffage = false;
            stateTemp.affichageSignatureActe = false;

            stateTemp.affichageDialogDesistement = false;
            stateTemp.afficheDialogSuppressionContact = false;
            stateTemp.afficheDialogSuppressionReservation = false;
            stateTemp.affichageDialogVeuillezEditerLeContact = false;
            stateTemp.afficheDialogConfirmationVerrouillageReservation = false;
            stateTemp.afficheDialogConfirmationValidationDonnees = false;
            stateTemp.afficheDialogSuppressionCommercialisateur = false;
            stateTemp.afficheDialogVerrouillageReservation = false;
            stateTemp.afficheDialogValidationReservation = false;
            stateTemp.messageDialogValidationReservation = '';
        }
        else {
            this.setState({
                affichageSectionContacts_ModeCreation: false,//new
                affichageSectionReservationTarifs_ModeCreation: false,
                affichageSectionReservationDates_ModeCreation: false,
                affichageSectionReservationEcheancier_ModeCreation: false,
                affichageSectionReservationCommentaire_ModeCreation: false,

                affichageFicheContact: false,
                affichageCommercialisateurs: false,
                affichageOngletDesSouhaits: false,
                affichageFicheReservation: false,
                affichageAcquereur: false,
                affichageCommercialisateur: false,
                affichageConditionsParticulieres: false,
                affichageDateAutre: false,
                affichageDateReservation: false,
                affichageDepotGarantie: false,
                affichageDossierClient: false,
                affichageEcheancier: false,
                affichageEtat: false,
                affichageLot: false,
                affichageNotaireClient: false,
                affichagePrix: false,
                affichageSuiviCompteClient: false,
                affichageTMA: false,
                affichageDemandes: false,
                affichageChecklist: false,

                affichagePanelAcquereurs: false,
                affichagePanelCommercialisateur: false,
                affichagePanelNotaire: false,
                affichagePanelFraisNotaire: false,
                affichagePanelDepotGarantie: false,
                affichagePanelCommentaire: false,
                affichagePanelTarif: false,
                affichagePanelDates: false,
                affichagePanelFinancement: false,
                affichagePanelCycle: false,
                affichagePanelSuiviNotaire: false,

                affichageSignatureClient: false,
                affichageValidationEiffage: false,
                affichageSignatureEiffage: false,
                affichageSignatureActe: false,

                affichageDialogDesistement: false,
                afficheDialogSuppressionContact: false,
                afficheDialogSuppressionReservation: false,
                affichageDialogVeuillezEditerLeContact: false,
                afficheDialogConfirmationVerrouillageReservation: false,
                afficheDialogConfirmationValidationDonnees: false,
                afficheDialogSuppressionCommercialisateur: false,
                afficheDialogVerrouillageReservation: false,
                afficheDialogValidationReservation: false,
                messageDialogValidationReservation: '',
            });
        }
    }

    //#region Affichage/Masquage des DIALOG
    _onAffichageDialogDesistement = () => {
        this.setState({ affichageDialogDesistement: true });
    }
    _onCacheDialogDesistement = () => {
        this.setState({ affichageDialogDesistement: false });
    };

    _onAffichageDialogSuppressionReservation = () => {
        this.setState({ afficheDialogSuppressionReservation: true });
    }
    _onCacheDialogSuppressionReservation = () => {
        this.setState({ afficheDialogSuppressionReservation: false });
    };

    _onAffichageDialogSuppressionContact = (idContact) => {
        this.setState({ afficheDialogSuppressionContact: true, idContactSelectionne: idContact });
    }
    _onCacheDialogSuppressionContact = () => {
        this.setState({ afficheDialogSuppressionContact: false });
    };

    _onAffichageDialogVeuillezEditerLeContact = () => {
        this.setState({ affichageDialogVeuillezEditerLeContact: true });
    };
    _onCacheDialogVeuillezEditerLeContact = () => {
        this.setState({ affichageDialogVeuillezEditerLeContact: false });
    };

    _onAffichageDialogConfirmationVerrouillageReservation = () => {
        this.setState({ afficheDialogConfirmationVerrouillageReservation: true });
    }
    _onCacheDialogConfirmationVerrouillageReservation = () => {
        this.setState({ afficheDialogConfirmationVerrouillageReservation: false });
    };

    _onAffichageDialogConfirmationValidationDonnees = () => {
        this.setState({ afficheDialogConfirmationValidationDonnees: true });
    }
    _onCacheDialogConfirmationValidationDonnees = () => {
        this.setState({ afficheDialogConfirmationValidationDonnees: false });
    };

    _onAffichageDialogSuppressionCommercialisateur = (commercialisateur) => {
        this.setState({ afficheDialogSuppressionCommercialisateur: true, commercialisateurSelectionne: commercialisateur });
    }
    _onCacheDialogSuppressionCommercialisateur = () => {
        this.setState({ afficheDialogSuppressionCommercialisateur: false, commercialisateurSelectionne: {} });
    };

    _onAffichageDialogValidationReservation = (message) => {
        this.setState({
            afficheDialogValidationReservation: true,
            messageDialogValidationReservation: message,
            afficheDialogConfirmationVerrouillageReservation: false//YD : 06/02/2020
        });
    }
    _onCacheDialogValidationReservation = () => {
        this.setState({
            afficheDialogValidationReservation: false,
            messageDialogValidationReservation: '',
            afficheDialogConfirmationVerrouillageReservation: false//YD : 06/02/2020
        });
    };
    //#endregion
    //#endregion

    //#region Mise à jour du state
    _majStateVerrouillageReservation = (estVerrouillee, callback) => {
        let ficheReservationTrav = { ...this.state.ficheReservation };
        let reservationTrav = { ...ficheReservationTrav.reservation };
        reservationTrav.estVerrouillee = estVerrouillee;
        ficheReservationTrav.reservation = reservationTrav;
        this.setState({ ficheReservation: ficheReservationTrav }, callback);
    };
    _majStateValidationCGReservation = (estValideeCG, callback) => {
        let ficheReservationTrav = { ...this.state.ficheReservation };
        let reservationTrav = { ...this.state.ficheReservation.reservation };
        reservationTrav.estValideeCG = estValideeCG;
        reservationTrav.dateValidationCG = (estValideeCG ? new Date() : null);
        ficheReservationTrav.reservation = reservationTrav;
        this.setState({ ficheReservation: ficheReservationTrav }, callback);
    };
    //#endregion

    //#region Chargement/Rechargement
    _chargementReservationEnModeCreation() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des informations de la réservation'
        },
            this._chargementFicheReservationEnModeCreation()
        );
    }
    _chargementFicheReservationEnModeCreation() {
        let listeDesPromisesAExecuter = [];
        let chargementLotCommercial = DataLotCommercial._chargementLotCommercial(this.props.idOperation, this.props.idLotCommercial);
        let chargementTitreOption = DataOption._chargementTitreOption(this.props.idOperation, this.props.idLotCommercial);
        let chargementMonCompte = DataCompte._chargementMonCompte();
        let chargementDroitsReservation = DataReservation._chargementDroitsReservation(this.props.idOperation, 0);

        listeDesPromisesAExecuter.push(chargementLotCommercial);
        listeDesPromisesAExecuter.push(chargementTitreOption);
        listeDesPromisesAExecuter.push(chargementMonCompte);
        listeDesPromisesAExecuter.push(chargementDroitsReservation);

        Promise.all(listeDesPromisesAExecuter)
            .then(responsePromise => {
                //*******************************************************************
                //déclaration des variables
                let chargementLotCommercialJSON = responsePromise[0];
                let chargementTitreOptionJSON = responsePromise[1];
                let chargementMonCompte = responsePromise[2];
                let chargementDroitsReservation = responsePromise[3];
                //*******************************************************************

                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responsePromise, this);

                if (retourVerif === null) {
                    //let objetData = responseFetch.reponseAPIobjet;

                    let lotcommercial = chargementLotCommercialJSON.reponseAPIobjet[1];
                    let tvaLotCommercial = chargementLotCommercialJSON.reponseAPIobjet[2];
                    let prixMaitrise = chargementLotCommercialJSON.reponseAPIobjet[3];
                    let listeDesTVAs = chargementLotCommercialJSON.reponseAPIobjet[4];
                    let contactAyantUneOptionDeRangUn = chargementLotCommercialJSON.reponseAPIobjet[5];
                    let commercialisateurOptionRangUn = chargementLotCommercialJSON.reponseAPIobjet[6];

                    if (tvaLotCommercial !== undefined) {
                        let prixHT = lotcommercial.prixHT;
                        if (prixHT != null)
                            prixHT = prixHT.toFixed(2);

                        let taux = parseFloat(tvaLotCommercial.taux);
                        let idTVACas = tvaLotCommercial.idTVACas; //let idCasTVA = tvaLotCommercial[0].idCasTVA;
                        let prixTTC = prixHT * (1 + taux);
                        if (prixTTC != null)
                            prixTTC = prixTTC.toFixed(2);

                        let labelPrixMaitrise = prixMaitrise.prixMaitrise;
                        let prixMaitriseHT = lotcommercial.prixMaitriseHT;
                        if (prixMaitriseHT != null)
                            prixMaitriseHT = prixMaitriseHT.toFixed(2);

                        //AF - Si un contact possede une option de rang 1 alors il doit apparaitre par défaut dans la liste des contacts
                        let listContacts = [...this.state.listContacts];

                        if (contactAyantUneOptionDeRangUn !== null) {
                            this._onAjouteContactALaListeDesContacts(contactAyantUneOptionDeRangUn, listContacts);
                            this._onAffichageDialogVeuillezEditerLeContact();
                        }

                        let reservationTrav = { ...this.state.reservation };
                        reservationTrav.prixHT = prixHT;
                        reservationTrav.prixTTC = prixTTC;
                        reservationTrav.prixMaitrise = labelPrixMaitrise;
                        reservationTrav.idTVACas = idTVACas;//reservationTrav.idCasTVA = idCasTVA;
                        reservationTrav.tauxTVA = taux;

                        let contactTrav = { ...this.state.contact };
                        contactTrav.idContact = null;

                        //Titre de la popup
                        let titre = this._chargementTitreReservation(chargementTitreOptionJSON);

                        let stateTemp = {};
                        stateTemp.reservation = reservationTrav;
                        stateTemp.contact = contactTrav;
                        stateTemp.listeDesTVAs = listeDesTVAs;
                        stateTemp.listContacts = listContacts;

                        this._onCacheTout(stateTemp);
                        stateTemp.affichageSectionContacts_ModeCreation = true;

                        stateTemp.titreReservation = titre;
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.idLotCommercial = this.props.idLotCommercial;
                        stateTemp.monCompte = chargementMonCompte.reponseAPIobjet;

                        this._chargementDroitAcquereur(stateTemp, chargementDroitsReservation.reponseAPIobjet[0]);

                        this._chargementDroitCommercialisateur(stateTemp, chargementDroitsReservation.reponseAPIobjet[1]);

                        //this._onChargementDesColumnsDesTableaux();

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, stateTemp, this._onChargementDesColumnsDesTableaux);

                        // Ticket 1154 - Charger le commercialisateur de l'option
                        if (commercialisateurOptionRangUn !== null) {
                            this._chargementMandatCommercialisationDuCommercialisateur(commercialisateurOptionRangUn[0].loginCompte, true);
                        }
                    }
                    else {
                        this.setState({
                            enCoursDeTraitement: false,
                            messageEnCoursTraitement: '',
                            hideMessageBarWarning: false,
                            warningMessage: 'Impossible de créer une réservation : aucune TVA renseignée pour cette opération'
                        });
                    }

                }
                else {
                    Immocom.onTraitementErreurPromise(this, retourVerif);
                }
            });

    }

    _chargementDroitAcquereur(stateTemp, objetDroitAcquereur) {
        let droitBlocAcquereur = objetDroitAcquereur.split(';#');
        stateTemp.peutAccederBlocAcquereur = (droitBlocAcquereur[1] === "True" ? true : false);
        stateTemp.peutAjouterBlocAcquereur = (droitBlocAcquereur[2] === "True" ? true : false);
        stateTemp.peutModifierBlocAcquereur = (droitBlocAcquereur[3] === "True" ? true : false);
        stateTemp.peutSupprimerBlocAcquereur = (droitBlocAcquereur[4] === "True" ? true : false);
    }
    _chargementDroitCommercialisateur(stateTemp, objetDroitCommercialisateur) {
        let droitBlocCommercialisateur = objetDroitCommercialisateur.split(';#');//YD : 02/06/2020
        stateTemp.peutAccederBlocCommercialisateur = (droitBlocCommercialisateur[1] === "True" ? true : false);
        stateTemp.peutAjouterBlocCommercialisateur = (droitBlocCommercialisateur[2] === "True" ? true : false);
        stateTemp.peutModifierBlocCommercialisateur = (droitBlocCommercialisateur[3] === "True" ? true : false);
        stateTemp.peutSupprimerBlocCommercialisateur = (droitBlocCommercialisateur[4] === "True" ? true : false);
    }

    _chargementReservation(affichagePanelAcquereurs, affichageCommercialisateurs, affichageEcheancier) {//YD : 06/02/2020
        if (this.props.idOperation !== 0 && this.props.idReservation !== 0) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement de la réservation'
            },
                this._chargementFicheReservation(affichagePanelAcquereurs, affichageCommercialisateurs, affichageEcheancier)//YD : 06/02/2020
            );
        }
    }
    _chargementFicheReservation = (affichagePanelAcquereurs, affichageCommercialisateurs, affichageEcheancier) => {//YD : 06/02/2020
        var _this = this;

        let listeDesPromisesAExecuter = [];
        let chargementFicheReservation = DataReservation._chargementFicheReservation(this.props.idOperation, this.props.idReservation);
        let chargementFinancement = DataFinancement._chargementFinancement(this.props.idOperation, this.props.idReservation);
        let chargementHistoriqueEtat = DataReservation._chargementFicheReservation_HistoriqueEtat(this.props.idOperation, this.props.idReservation);
        let chargementTitreReservation = DataReservation._chargementTitreReservation(this.props.idOperation, this.props.idReservation);
        //let chargementListeDesReservations = DataReservation._chargementListeDesReservations(this.props.idOperation, this.props.inclureVentesEnBloc);

        listeDesPromisesAExecuter.push(chargementFicheReservation);
        listeDesPromisesAExecuter.push(chargementFinancement);
        listeDesPromisesAExecuter.push(chargementHistoriqueEtat);
        listeDesPromisesAExecuter.push(chargementTitreReservation);
        //listeDesPromisesAExecuter.push(chargementListeDesReservations);

        Promise.all(listeDesPromisesAExecuter)
            .then(responsePromise => {
                //*******************************************************************
                //déclaration des variables
                let chargementFicheReservationJSON = responsePromise[0];
                let chargementFinancementJSON = responsePromise[1];
                let chargementHistoriqueEtatJSON = responsePromise[2];
                let chargementTitreReservationJSON = responsePromise[3];
                //let chargementListeDesReservationsJSON = responsePromise[4];
                //*******************************************************************
                
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responsePromise, _this);

                if (retourVerif === null) {
                    const stateTemp = {};

                    //#region Fiche de réservation
                    stateTemp.idReservation = _this.props.idReservation;
                    stateTemp.idOperation = _this.props.idOperation;
                    stateTemp.ficheReservation = {
                        estChargee: true,
                        reservation: chargementFicheReservationJSON.reponseAPIobjet[0],
                        listSouhaits: chargementFicheReservationJSON.reponseAPIobjet[1],
                        tva: chargementFicheReservationJSON.reponseAPIobjet[2],
                        listLots: chargementFicheReservationJSON.reponseAPIobjet[3],
                        prixMaitrise: chargementFicheReservationJSON.reponseAPIobjet[4],
                        listTVA: chargementFicheReservationJSON.reponseAPIobjet[5],
                        listCommercialisateurs: chargementFicheReservationJSON.reponseAPIobjet[6],
                        listContacts: chargementFicheReservationJSON.reponseAPIobjet[7],
                        nbADF: chargementFicheReservationJSON.reponseAPIobjet[9],
                        lotCommercial: chargementFicheReservationJSON.reponseAPIobjet[10],
                        echeancier: chargementFicheReservationJSON.reponseAPIobjet[11],
                        existeDocumentsSigneEiffage: chargementFicheReservationJSON.reponseAPIobjet[12],
                        existeDocumentsASignerParEiffage: chargementFicheReservationJSON.reponseAPIobjet[13]
                    };
                    //stateTemp.affichageFicheReservation = true;
                    stateTemp.affichageSuiviCompteClient = false;
                    stateTemp.affichageTMA = false;
                    stateTemp.affichageDemandes = false;
                    stateTemp.affichageChecklist = false;
                    stateTemp.affichageDossierClient = false;
                    //stateTemp.affichagePanelAcquereurs = (affichagePanelAcquereurs !== undefined ? affichagePanelAcquereurs : false);//YD : 06/02/2020
                    stateTemp.affichageCommercialisateurs = (affichageCommercialisateurs !== undefined ? affichageCommercialisateurs : false);//YD : 06/02/2020
                    stateTemp.affichageEcheancier = (affichageEcheancier !== undefined ? affichageEcheancier : false);//YD : 06/02/2020

                    if (!stateTemp.affichagePanelAcquereurs && !stateTemp.affichageCommercialisateurs && !stateTemp.affichageEcheancier) {//YD : 06/02/2020
                        stateTemp.affichageFicheReservation = true;//YD : 06/02/2020
                    }//YD : 06/02/2020
                    /*CONTACT */
                    this._chargementDroitAcquereur(stateTemp, chargementFicheReservationJSON.reponseAPIobjet[14]);

                    /*COMMERCIALISATEUR */
                    this._chargementDroitCommercialisateur(stateTemp, chargementFicheReservationJSON.reponseAPIobjet[15]);

                    /*CONDITIONS PARTICULIERES */
                    let droitBlocConditionsParticulieres = chargementFicheReservationJSON.reponseAPIobjet[16].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocConditionsParticulieres = (droitBlocConditionsParticulieres[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocConditionsParticulieres = (droitBlocConditionsParticulieres[3] === "True" ? true : false);//YD : 06/02/2020

                    /*PAS UTILISE */
                    //let droitBlocDateAutre = chargementFicheReservationJSON.reponseAPIobjet[17].split(';#');//YD : 02/06/2020

                    /*DATE RESA */
                    let droitBlocDateReservation = chargementFicheReservationJSON.reponseAPIobjet[18].split(';#');//YD : 02/06/2020
                    stateTemp.peutAccederBlocDateReservation = (droitBlocDateReservation[1] === "True" ? true : false);
                    stateTemp.peutModifierBlocDateReservation = (droitBlocDateReservation[3] === "True" ? true : false);

                    /*DEPOT DE GARANTIE */
                    let droitBlocDepotGarantie = chargementFicheReservationJSON.reponseAPIobjet[19].split(';#');//YD : 02/06/2020
                    stateTemp.peutAccederBlocDepotGarantie = (droitBlocDepotGarantie[1] === "True" ? true : false);
                    stateTemp.peutModifierBlocDepotGarantie = (droitBlocDepotGarantie[3] === "True" ? true : false);

                    /*DOSSIER CLIENT */
                    let droitBlocDossierClient = chargementFicheReservationJSON.reponseAPIobjet[20].split(';#');//YD : 02/06/2020
                    stateTemp.peutAccederBlocDossierClient = (droitBlocDossierClient[1] === "True" ? true : false);
                    stateTemp.peutAjouterBlocDossierClient = (droitBlocDossierClient[2] === "True" ? true : false);
                    stateTemp.peutModifierBlocDossierClient = (droitBlocDossierClient[3] === "True" ? true : false);

                    /*ECHEANCIER */
                    let droitBlocEcheancier = chargementFicheReservationJSON.reponseAPIobjet[21].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocEcheancier = (droitBlocEcheancier[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocEcheancier = (droitBlocEcheancier[3] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutSupprimerBlocEcheancier = (droitBlocEcheancier[4] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutVerrouillerEcheancier = (droitBlocEcheancier[5] === "True" ? true : false);

                    /*ETAT */
                    let droitBlocEtat = chargementFicheReservationJSON.reponseAPIobjet[22].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocEtat = (droitBlocEtat[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocEtat = (droitBlocEtat[3] === "True" ? true : false);//YD : 06/02/2020

                    /*FINANCEMENT */
                    let droitBlocFinancement = chargementFicheReservationJSON.reponseAPIobjet[23].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocFinancement = (droitBlocFinancement[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutAjouterBlocFinancement = (droitBlocFinancement[2] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocFinancement = (droitBlocFinancement[3] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutSupprimerBlocFinancement = (droitBlocFinancement[4] === "True" ? true : false);//YD : 06/02/2020

                    /*LOT */
                    //let droitBlocLot = chargementFicheReservationJSON.reponseAPIobjet[24].split(';#');//YD : 06/02/2020

                    /*NOTAIRE */
                    let droitBlocNotaire = chargementFicheReservationJSON.reponseAPIobjet[25].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocNotaire = (droitBlocNotaire[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocNotaire = (droitBlocNotaire[3] === "True" ? true : false);//YD : 06/02/2020

                    /*TARIF */
                    let droitBlocPrix = chargementFicheReservationJSON.reponseAPIobjet[26].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocPrix = (droitBlocPrix[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocPrix = (droitBlocPrix[3] === "True" ? true : false);//YD : 06/02/2020

                    /*SUIVI COMPTE CLIENT */
                    let droitBlocSuiviCompteClient = chargementFicheReservationJSON.reponseAPIobjet[27].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocSuiviCompteClient = (droitBlocSuiviCompteClient[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutAjouterBlocSuiviCompteClient = (droitBlocSuiviCompteClient[2] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocSuiviCompteClient = (droitBlocSuiviCompteClient[3] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutSupprimerBlocSuiviCompteClient = (droitBlocSuiviCompteClient[4] === "True" ? true : false);//YD : 06/02/2020

                    /*TMA */
                    let droitBlocTMA = chargementFicheReservationJSON.reponseAPIobjet[28].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocTMA = (droitBlocTMA[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutAjouterBlocTMA = (droitBlocTMA[2] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocTMA = (droitBlocTMA[3] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutSupprimerBlocTMA = (droitBlocTMA[4] === "True" ? true : false);//YD : 06/02/2020

                    /*BACK OFFICE */
                    stateTemp.peutAccederBlocDemandes = chargementFicheReservationJSON.reponseAPIobjet[39] || false;
                    stateTemp.peutAccederBlocChecklist = stateTemp.peutAccederBlocDemandes;

                    /*Suivi Notaire*/
                    let droitBlocSuiviNotaire = chargementFicheReservationJSON.reponseAPIobjet[38].split(';#');//BL : 17/05/2020
                    stateTemp.peutAccederBlocSuiviNotaire = (droitBlocSuiviNotaire[1] === "True" ? true : false)//BL : 17/05/2020
                    stateTemp.peutModifierBlocSuiviNotaire = (droitBlocSuiviNotaire[2] === "True" ? true : false)//BL : 17/05/2020
                    /*SUPPRESSION, DESISTEMENT DE LA RESERVATION*/
                    stateTemp.peutSupprimer = chargementFicheReservationJSON.reponseAPIobjet[29];
                    stateTemp.peutDesister = chargementFicheReservationJSON.reponseAPIobjet[30];

                    //CHOIXECHEANCIER
                    stateTemp.peutModifierChoixEcheancier = chargementFicheReservationJSON.reponseAPIobjet[32];
                    if (chargementFicheReservationJSON.reponseAPIobjet[0].validee) {
                        stateTemp.ficheReservation.reservation.validee = true;
                        stateTemp.onActiveVerrouillageReservation = true;
                        //stateTemp.onActiveBonASignerEiffageReservation = true;
                    } else {
                        stateTemp.ficheReservation.reservation.validee = false;
                        stateTemp.ficheReservation.reservation.estVerrouillee = false;
                        stateTemp.onActiveVerrouillageReservation = false;
                    }

                    //AF - 11/03/2020
                    stateTemp.activationValidation = chargementFicheReservationJSON.reponseAPIobjet[33];

                    //AF - 20/05/2020
                    stateTemp.activationValidationCG = chargementFicheReservationJSON.reponseAPIobjet[34];

                    /*FRAIS NOTAIRE */
                    const droitBlocFraisNotaire = chargementFicheReservationJSON.reponseAPIobjet[35].split(';#');//YD : 06/02/2020
                    stateTemp.peutAccederBlocFraisNotaire = (droitBlocFraisNotaire[1] === "True" ? true : false);//YD : 06/02/2020
                    stateTemp.peutModifierBlocFraisNotaire = (droitBlocFraisNotaire[3] === "True" ? true : false);//YD : 06/02/2020

                    stateTemp.dernierCycleReservation = chargementFicheReservationJSON.reponseAPIobjet[36];
                    //#endregion

                    //#region Financement
                    stateTemp.listFinancements = chargementFinancementJSON.reponseAPIobjet;
                    //#endregion

                    //#region Titre de la popup
                    let titre = _this._chargementTitreReservation(chargementTitreReservationJSON);
                    stateTemp.titreReservation = titre;
                    //#endregion

                    //#region Etats de réservation
                    let listEtatsReservationTrav = [];
                    let etapeActive = 0;
                    //let _this = this;

                    chargementHistoriqueEtatJSON.reponseAPIobjet.forEach(function (etat, index) {
                        let dateReelle = _this._getDateReelleEtatReservation(etat.idCycleReservation, stateTemp.ficheReservation.reservation);
                        let iconeTrav = _this._getIconeEtatReservation(etat.idCycleReservation, dateReelle);
                        let dateModificationEtatReservation = (etat.modifierLe !== null ? Scriba.date().stringDateFormatCourt(etat.modifierLe) : '');

                        let numEtape = index + 1;
                        if (!!dateReelle) etapeActive = numEtape;
                        listEtatsReservationTrav.push({
                            numEtape,
                            icone: iconeTrav,
                            nomEtape: etat.cycleReservation,
                            sousTitre: dateReelle,
                            tooltip: dateModificationEtatReservation,
                            onClick: () => _this._onAffichagePanelCycle(etat.idCycleReservation)
                        });

                    });

                    stateTemp.listEtatsReservation = listEtatsReservationTrav;
                    stateTemp.etapeActive = etapeActive;
                    //#endregion

                    //#region Liste des réservations
                    //let listeDesReservations = [];

                    //chargementListeDesReservationsJSON.reponseAPIobjet.forEach(function (reservation, index) {

                    //    let droitSplit = reservation.droits.split(';#');
                    //    let peutReserver = (droitSplit[3] === "1");
                    //    let peutAccederReservation = (droitSplit[2] === "1");

                    //    if (!peutReserver && peutAccederReservation) {
                    //        listeDesReservations.push({
                    //            key: reservation.idReservation,
                    //            text: reservation.numero
                    //        });
                    //    }
                    //});

                    //stateTemp.listeDesReservations = listeDesReservations;
                    //#endregion

                    // Ne pas enlever sinon chargement des colonnes des blocs Financement et Lots KO
                    this._onChargementDesColumnsDesTableaux();

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(_this, stateTemp, true, this._onChargementDesColumnsDesTableaux);

                    if (affichagePanelAcquereurs === true) {
                        this.setState({ affichagePanelAcquereurs: affichagePanelAcquereurs });
                    }
                }
                else {
                    Immocom.onTraitementErreurPromise(_this, retourVerif);
                }
            });
    }
    _chargementTitreReservation(chargementTitreOptionJSON) {
        let titre = null;

        if (chargementTitreOptionJSON.reponseAPIobjet.length > 0) {

            let objetData = chargementTitreOptionJSON.reponseAPIobjet[0];

            titre = objetData.nomCommercial + " - " +
                objetData.nature + " " +
                objetData.lotType + " N° " +
                objetData.numero + " - " +
                (objetData.surfaceHabitable !== null ? Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(objetData.surfaceHabitable.toFixed(2), false, 2) + " m²" : '') +
                (objetData.prixTTC !== null ? " - " + Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(objetData.prixTTC.toFixed(2), false, 2) + " €" : "");
        }
        else {
            let objetData = chargementTitreOptionJSON.reponseAPIobjet;
            titre = " N° " + objetData.numero
        }

        return 'Réservation / ' + titre;
    }
    _chargementReservationSimple() {
        if (this.props.idOperation !== 0 && this.props.idReservation !== 0) {
            this.setState(
                {
                    enCoursDeTraitement: true,
                    messageEnCoursTraitement: 'Chargement de la réservation'
                },
                this._chargementFicheReservationSimple()
            );
        }
    }
    _chargementFicheReservationSimple() {
        let ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

        ficheReservation_Simple
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = { ...this.state };
                    stateTemp.ficheReservation.reservation = objetData[0];
                    stateTemp.affichageFicheReservation = true;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp, true, this._onChargementDesColumnsDesTableaux);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });

    }
    _chargementFinancement() {
        let chargementFinancement = DataFinancement._chargementFinancement(this.props.idOperation, this.props.idReservation);

        chargementFinancement
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);


                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = { ...this.state };
                    stateTemp.listFinancements = objetData;
                    stateTemp.affichageFicheReservation = true;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp, true, this._onChargementDesColumnsDesTableaux);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });

    }

    _chargementEcheancier = (onAfficheMessageDeChargement) => {
        if (Immocom.getSiPropsRenseignee(onAfficheMessageDeChargement) && onAfficheMessageDeChargement) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: "Chargement de l'échéancier"
            });
        }

        let state = {};
        this._onCacheTout(state);
        state.affichageSectionReservationEcheancier_ModeCreation = true;
        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state, onAfficheMessageDeChargement);
    };

    _chargementCommercialisateurs() {
        if (!this.state.peutModifierBlocCommercialisateur) {
            // On passe l'étape Commercialisateur
            this._chargementMandatCommercialisationDuCommercialisateur(this.state.monCompte.compteTrav.loginCompte, false);
        }
        else {
            if (this.state.idOperation !== 0 && this.state.idLotCommercial !== 0) {
                let stateTemp = {};
                this._onCacheTout(stateTemp);
                stateTemp.affichageCommercialisateurs = true;

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
            }
        }
    }
    _chargementMandatCommercialisationDuCommercialisateur(loginCompte, chargementDepuisOptionExistante) {
        if (loginCompte !== undefined && loginCompte != null) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du commercialisateur en cours'
            });

            //let _onChargementMandatCommercialisateurSelectionne = DataCommercialisateur._onChargementMandatCommercialisateurSelectionne(loginCompte, this.state.idOperation, this.state.idLotCommercial);
            let _onChargementMandatCommercialisateurSelectionne = DataMandat._chargementMandatCommercialisateurLePlusBasPourUnLotCommercial(this.state.idOperation, this.state.idLotCommercial, loginCompte);

            _onChargementMandatCommercialisateurSelectionne
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        if (objetData != null) {
                            this._chargementLotCommercial(objetData, chargementDepuisOptionExistante);
                        }
                        else {
                            this.setState({
                                enCoursDeTraitement: false,
                                messageEnCoursTraitement: '',
                                hideMessageBarError: false,
                                errorMessage: 'Aucun mandat valide pour la société et le commercialisateur sélectionnés'
                            });
                        }
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }
    _chargementLotCommercial(objetDataParametre, chargementDepuisOptionExistante) {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du lot commercial'
        });

        let chargementLotCommercial = DataLotCommercial._chargementLotCommercial(this.state.idOperation, this.props.idLotCommercial);

        chargementLotCommercial
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let lotcommercial = objetData[1];
                    let tvaOperation = objetData[2];
                    let prixHT = lotcommercial.prixHT;

                    if (tvaOperation !== undefined) {
                        let tvaLot = tvaOperation.taux;
                        let prixTTCLot = prixHT * (1 + tvaLot);

                        if (objetDataParametre.honoraireCommercialisation !== undefined && objetDataParametre.honoraireCommercialisation != null) {
                            //// Calcul des honoraires
                            //let honorairesCalcules = null;

                            //let honorairesCommercialisation = objetDataParametre.honoraireCommercialisation.replace('%', '').replace(',', '.');

                            //if (objetDataParametre.baseCalculHonoraireCommercialisation === "HT sur TTC") {
                            //    let honorairesContractuels = (prixTTCLot * parseFloat(honorairesCommercialisation)) / 100;
                            //    honorairesCalcules = honorairesContractuels;
                            //}
                            //else if (objetDataParametre.baseCalculHonoraireCommercialisation === "TTC sur HT") {
                            //    let honorairesContractuels = ((prixTTCLot * parseFloat(honorairesCommercialisation)) / 100) / (1 + tvaLot);
                            //    honorairesCalcules = honorairesContractuels;
                            //}

                            //honorairesCalcules = honorairesCalcules.toFixed(2);

                            // Calcul des honoraires
                            let honorairesCalcules = 0;
                            let pourcentageHonorairesCalcules = 0;

                            //MG - 25/05/2023 - 2335/2239
                            const result = Immocom.calculationHonoraireReel(objetDataParametre.honoraireCommercialisation, objetDataParametre.baseCalculHonoraireCommercialisation, prixTTCLot, prixHT);
                            honorairesCalcules = result !== undefined ? result.honoraireReel.toFixed(2) : 0;
                            pourcentageHonorairesCalcules = result !== undefined ? result.percentageHonoraire.toFixed(2) : 0;

                            // Ticket 1154 - Si on vient d'une option, on récupère le commercialisateur automatiquement
                            let commercialisateurOption = null;
                            if (objetData[6] != null)
                                commercialisateurOption = objetData[6][0];

                            let stateTemp = {};
                            stateTemp.listCommercialisateurs = [{
                                loginCompte: objetDataParametre.loginCompte,
                                idSociete: objetDataParametre.idSociete,
                                idMandat: objetDataParametre.idMandat,
                                nomSociete: (chargementDepuisOptionExistante ? (commercialisateurOption !== null ? commercialisateurOption.nomSociete : '') : this.state.monCompte.saSociete.nom),
                                nomComplet: (chargementDepuisOptionExistante ? (commercialisateurOption !== null ? commercialisateurOption.nom + ' ' + commercialisateurOption.prenom : '') : this.state.monCompte.compteTrav.nom + ' ' + this.state.monCompte.compteTrav.prenom),
                                honoraireCommercialisation: objetDataParametre.honoraireCommercialisation,
                                baseCalculHonoraireCommercialisation: objetDataParametre.baseCalculHonoraireCommercialisation,
                                exclusivite: objetDataParametre.exclusivite,
                                //honoraireReelHT: honorairesCalcules,
                                honoraireReelNombre: honorairesCalcules,
                                honoraireReelPourcentage: pourcentageHonorairesCalcules,
                                honorairesContractuels: honorairesCalcules
                            }];

                            if (!chargementDepuisOptionExistante) {
                                this._onCacheTout(stateTemp);
                                stateTemp.affichageCommercialisateurs = true;
                            }

                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                            this._onChargementDesColumnsDesTableaux();
                        }
                        else {
                            this.setState({
                                enCoursDeTraitement: false,
                                messageEnCoursTraitement: '',
                                hideMessageBarWarning: false,
                                warningMessage: 'Aucun honoraire renseigné'
                            });
                        }
                    }
                    else {
                        this.setState({
                            enCoursDeTraitement: false,
                            messageEnCoursTraitement: '',
                            hideMessageBarWarning: false,
                            warningMessage: 'Aucune TVA renseignée pour cette opération'
                        });
                    }
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onRechargementApresModificationReservation = () => {
        this._chargementReservation(false, false, true);
    };
    _onRechargeLesCommercialisateurs = (affichageCommercialisateurs) => {
        let chargementCommercialisationDeLaReservation = DataCommercialisation._onRechargementCommercialisationDeLaReservation(this.props.idOperation, this.props.idReservation);

        chargementCommercialisationDeLaReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = { ...this.state };

                    this._onCacheTout(stateTemp);

                    stateTemp.ficheReservation.listCommercialisateurs = objetData;
                    stateTemp.affichageCommercialisateurs = (affichageCommercialisateurs == undefined ? true : affichageCommercialisateurs);

                    stateTemp.affichageFicheReservation = true;

                    this._onChargementDesColumnsDesTableaux();

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }
    _onRechargeLesContacts = () => {
        let chargementContactDeLaReservation = DataContact._onRechargementContactDeLaReservation(this.props.idOperation, this.props.idReservation);

        chargementContactDeLaReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = { ...this.state };

                    this._onCacheTout(stateTemp);

                    stateTemp.ficheReservation.listContacts = objetData;
                    stateTemp.affichagePanelAcquereurs = true;

                    stateTemp.affichageFicheReservation = true;

                    this._onChargementDesColumnsDesTableaux();

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onRenderDetailsHeader(props, defaultRender) {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    }
    _onRenderFooterContentContact = () => {

        //AF - Lorsque la liste contient par défaut le contact qui a une option de rang 1, le souhait n'est pas encore selectionné.
        //On autorise de poursuivre uniquement si la liste contient des contacts et que chacun de ces contacts possede un souhait selectionné.
        //--------------------------------------
        //let disabledButton = (this.state.listContacts.length <= 0);
        let disabledButton = false;

        if (this.state.listContacts.length > 0) {
            this.state.listContacts.forEach(function (contact, index) {
                if (contact.idSouhait === undefined || contact.idSouhait === null) {
                    disabledButton = true;
                    return;
                }
            });
        } else {
            disabledButton = true;
        }
        //--------------------------------------

        return (
            <div>
                <PrimaryButton name="buttonSuivant1" onClick={() => this._chargementCommercialisateurs()} className="boutonReservation" disabled={disabledButton}>Suivant</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()} >Annuler</DefaultButton>
            </div>
        );
    }
    _onRenderFooterContentCommercialisateur = () => {
        let disabledButton = (this.state.listCommercialisateurs.length <= 0);

        return (
            <div>
                <DefaultButton onClick={() => this._onAffichageListeContacts(false, null)} className="boutonReservation">Précédent</DefaultButton>
                <PrimaryButton name="buttonSuivant2" onClick={() => this._onAffichageReservationTarifs()} className="boutonReservation" disabled={disabledButton}>Suivant</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };
    _onRenderFooterContentTarifs = () => {
        // KP (2020/02/27) : correction erreur "Input string was not in a correct format" à la validation d'une résa
        // Boolean(x) : false si x = undefined ou null ou "" ou 0 ; true si x = "0"
        //AF - Ticket 996 - On peut avoir une TVA à 0 
        //let disabledButton = (!Boolean(this.state.reservation.prixHT) || !Boolean(this.state.reservation.prixTTC)); //(this.state.reservation.tauxTVA <= 0) ||  

        let disabledButton = !this.state.onActiveBoutonEnregistrer;//!this.state.onActiveBoutonTarifReservationEnregistrer;

        return (
            <div>
                <DefaultButton onClick={() => this._chargementCommercialisateurs()} className="boutonReservation">Précédent</DefaultButton>
                <PrimaryButton name="buttonSuivant3" onClick={() => this._onAffichageReservationDates()} className="boutonReservation" disabled={disabledButton}>Suivant</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };
    _onRenderFooterContentDates = () => {
        let disabledButton = !this.state.onActiveBoutonEnregistrer;

        return (
            <div>
                <DefaultButton onClick={() => this._onAffichageReservationTarifs()} className="boutonReservation">Précédent</DefaultButton>
                <PrimaryButton name="buttonSuivant4" onClick={() => this._chargementEcheancier(true)} className="boutonReservation" disabled={disabledButton}>Suivant</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };
    _onRenderFooterContentEcheancier = () => {
        let disabledButton = !this.state.onActiveBoutonEnregistrer || !this.state.reservation.idEcheancier;

        return (
            <div>
                <DefaultButton onClick={() => this._onAffichageReservationDates()} className="boutonReservation">Précédent</DefaultButton>
                <PrimaryButton name="buttonSuivant5" onClick={() => this._onAffichageReservationCommentaire()} className="boutonReservation" disabled={disabledButton}>Suivant</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };
    _onRenderFooterContentCommentaire = () => {
        let disabledButton = !this.state.onActiveBoutonEnregistrer;

        return (
            <div>
                <DefaultButton onClick={() => this._chargementEcheancier(true)} className="boutonReservation">Précédent</DefaultButton>
                <PrimaryButton name="buttonTerminer" onClick={() => this._onEnregistrementCreation()} className="boutonReservation" disabled={disabledButton}>Terminer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };
    _onRenderFooterContentReservation = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };
    //#endregion

    _onSelectionSouhait = (objetSouhait) => {
        if (objetSouhait != null) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du contact sélectionné'
            });

            let _chargementFicheReservation_ChargementDuContactSelectionne = DataReservation._chargementFicheReservation_ChargementDuContactSelectionne(objetSouhait._items[0].idContact, objetSouhait._items[0].idSouhait);

            _chargementFicheReservation_ChargementDuContactSelectionne
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let contact = responseFetch.reponseAPIobjet[0];

                        this._onAffichageListeContacts(false, contact);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onSelectionOnglet = (onglet) => () => {
        this.setState({
            affichageAcquereur: false,
            affichageChecklist: false,
            affichageCommercialisateur: false,
            affichageConditionsParticulieres: false,
            affichageDateAutre: false,
            affichageDateReservation: false,
            affichageDemandes: false,
            affichageDepotGarantie: false,
            affichageDossierClient: false,
            affichageEcheancier: false,
            affichageEtat: false,
            affichageFicheReservation: false,
            affichageLot: false,
            affichageNotaireClient: false,
            affichagePanelAcquereurs: false,
            affichagePanelCommentaire: false,
            affichagePanelCommercialisateur: false,
            affichagePanelCycle: false,
            affichagePanelDates: false,
            affichagePanelDepotGarantie: false,
            affichagePanelFinancement: false,
            affichagePanelFraisNotaire: false,
            affichagePanelNotaire: false,
            affichagePanelTarif: false,
            affichagePrix: false,
            affichageSuiviCompteClient: false,
            affichageTMA: false,
            [`affichage${onglet}`]: true
        });
    };

    _getIconeEtatReservation(etat, date) {
        let icone = null;

        if (date === null || date === "") {
            switch (etat) {
                case 10: //Initiale
                    icone = "Permissions";
                    break;
                case 20: //Signée client
                    icone = "InsertSignatureLine";
                    break;
                case 30: //Validée Eiffage
                    icone = "CheckMark";
                    break;
                case 35: //Signée Eiffage
                    icone = "WhiteBoardApp16";
                    break;
                case 40: //Actée
                    icone = "DecisionSolid";
                    break;
                default:
                    icone = "CheckMark";
                    break;
            }
        }
        else {
            icone = "CompletedSolid";
        }

        return icone;
    }

    _getDateReelleEtatReservation(etat, reservationTrav) {
        let dateDeLaReservation = null;

        switch (etat) {
            case 10: //Initiale
                dateDeLaReservation = Scriba.date().stringDateFormatCourt(reservationTrav.dateReservation);
                break;
            case 20: //Signée client
                dateDeLaReservation = (reservationTrav.dateSignatureElectronique !== null ? Scriba.date().stringDateFormatCourt(reservationTrav.dateSignatureElectronique) : Scriba.date().stringDateFormatCourt(reservationTrav.dateDeSignatureManuelle));
                break;
            case 30: //Validée Eiffage
                dateDeLaReservation = Scriba.date().stringDateFormatCourt(reservationTrav.dateValidation);
                break;
            case 35: //Signée Eiffage
                dateDeLaReservation = (reservationTrav.dateSignatureEiffageElectronique !== null ? Scriba.date().stringDateFormatCourt(reservationTrav.dateSignatureEiffageElectronique) : Scriba.date().stringDateFormatCourt(reservationTrav.dateDeSignatureEiffageManuelle));
                break;
            case 40: //Actée
                dateDeLaReservation = Scriba.date().stringDateFormatCourt(reservationTrav.dateSignatureActe);
                break;
        }

        return dateDeLaReservation;
    }

    _onOpen = () => {
        if (this.props.idReservation === 0 || this.props.idReservation == null) {
            // this._chargementMonCompte();
            this._chargementReservationEnModeCreation();
        }
        else {
            this._chargementReservation();
        }
    }

    componentDidMount() {
        if (this.props.provientDeADVv2) {
            this._onOpen();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        //Passe dedans uniquement lors du changement de réservation via la combo du panel
        if ((prevProps.idReservation !== null && prevProps.idReservation !== 0) &&
            (this.props.idReservation !== null && this.props.idReservation !== 0) &&
            (prevProps.idReservation !== this.props.idReservation)) {

            this._chargementReservation();
        }
    }

    render() {
        let content = this._creationContent();

        return (<div>{content}</div>);
    }
}